import Swal from 'sweetalert2';
import { NavOption, NavOptionGroup, NavOptionState, NavOptionTypeEnum } from '../components/feature/AfrNavigator';
import { SelectableListItem } from '../components/feature/BypassRequest';
import { ConceptNode } from '../redux/AccountsSlice';
import {
    AffiliateReporting, Afr,
    AfrVersion,
    Audit, AuditMessage, Certification,
    DimensionIdReference,
    DimensionReference,
    ErrorFactReference,
    Fact, FactTable,
    FactTableRow,
    MatchTableFacts,
    Table,
    bulkFactValues,
    clearMatchingTableFacts,
    existFactsInTable,
    factValue,
    generateLocalStateFromEventProperties, getFact,
    getFirstDocumentIndexFromRole,
    getMatchingFacts,
    getMergedAEs, getRow,
    getTable, getTableTotals,
    hasDiscreteAffiliates, isFundGroupOriented,
    replaceTableFacts,
    updateAffiliateReport,
    updateTableFact,
    TableBreakdownEntry
} from '../redux/AfrSlice';
import { Concept } from '../redux/ConceptSlice';
import { EntityContactRole, EntityUserRole, ReportAccessEnum } from '../redux/ContactSlice';
import { DocumentRelationship } from '../redux/DocumentsSlice';
import { Entity, getNameForAfr } from '../redux/EntitySlice';
import { getAffiliates, getReplaceTableFacts, getSelector, getTableFacts, resetAffiliates, resetReplaceTableFacts, resetTableFacts, setIsDirty, setReplaceTableFacts, updateTableCell } from '../redux/MiscSlice';
import { ActiveTaxonomyVersionInfo, TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';
import { EntityAuthorization, UserEntityAuthorizationEnum, UserRoleEnum, getAuthorization } from '../redux/UserSlice';
import { logerUser } from '../redux/UsersSlice';
import { AFRError, ErrorGrid, ErrorSummaryAFRSection, Section, addBusinessRulesErrors, getErrorList, updateErrors } from '../redux/ValidationSlice';
import dateHelper from './dateHelper';
import enums from './enums';

export interface StyledSelectableListItem {
    label: string;
    value: string;
    disabled: boolean;
    checked: boolean;
    className: string;
    children: Array<StyledSelectableListItem>;
}

export interface AccountRangeFilter {
    first: string;
    last: string;
    exclude: string[];
}

export default class utilityHelper {

    static IsAFRVerified(afr: Afr | null) {

        if (afr && afr.status === enums.AFRStatus.verified) {
            return true;
        }
        return false;
    }

    static IsReportedByPrimary(afr: Afr | null) {

        if (afr && afr.status === enums.AFRStatus.reported_by_primary) {
            return true;
        }
        return false;
    }

    static hasFacts(facts: Fact[] | null): boolean {
        if (!facts || facts.length === 0) {
            return false;
        }
        return true;
    }
    static hasErrorFacts(afr: Afr): boolean {
        if (!afr.currentversion) {
            return false;
        }
        if (utilityHelper.hasFacts(afr.currentversion.invalidFacts)) {
            return true;
        }
        if (utilityHelper.hasFacts(afr.currentversion.missingFacts)) {
            return true;
        }
        if (utilityHelper.hasFacts(afr.currentversion.unassignedFacts)) {
            return true;
        }
        return false;
    }
    /* check if AFR status is in the list delimited by ","  */
    static checkStatusList(afr: Afr | null, statusList: string) {
        if (!afr) {
            return false;
        }
        var statuses = statusList.split(",")
        for (var s in statuses) {

            if (afr.status === statuses[s]) {
                if (utilityHelper.hasErrorFacts(afr)) {
                    return false;
                }
                return true;
            }
        }
        return false;

    }

    static isAfrAtLeastSubmitted(afr: Afr | null): boolean {
        let result: boolean = false;

        if (afr) {
            var verifiedStatuses = enums.verifiedCertifiedRecertified.split(",");
            if (verifiedStatuses.some((element: string) => element == afr.status)) {
                result = true;
            }
        }

        return result;
    }

    /* Verify if the certification section is editable or not */
    static isLockedCertification(afr: Afr | null, role: string | null) {

        if (utilityHelper.checkStatusList(afr, enums.verifiedCertifiedRecertified)) {
            if (!(utilityHelper.IsAFRVerified)) {
                return true;
            }
            if (role != null && role != "ADMIN") {
                return true;
            }
        }
        return false;
    }


    static toProperCase = function (s: string) {
        return s.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase(); });
    };

    static SnakeCaseToTitleCase = function (value: string) {
        return value.toLowerCase().replace(/^[-_]*(.)/, (_, c) => c.toUpperCase())
            .replace(/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());
    }

    static camelCaseToTitleCase = function (value: string) {
        return value.replace(/([A-Z][a-z])/g, " $1")
            .replace(/\s*([A-Z]+)/g, " $1")
            .replace(/./, m => m.toUpperCase())
            .trim();
    }

    static toTitleCase = function (str: string | null) {
        if (str !== null && ((typeof str) !== "undefined")) {
            if (str.indexOf("-") > 0) {
                // Don't apply title case to hyphenated names
                return str;
            }
            return str.toLowerCase().replace(/_/g, " ").split(' ').map(function (word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');
        } else {
            return "";
        }
    }

    static wordsToTitleCase = function (str: string | null) {
        if (str !== null && ((typeof str) !== "undefined")) {
            if (str.indexOf("-") > 0) {
                // Don't apply title case to hyphenated names
                return str;
            }
            return str.toLowerCase().split(' ').map(function (word) {
                return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' ');
        } else {
            return "";
        }
    }

    // Helper to get a value
    static getNumber = (e: any) => {
        var result = Number(e);
        if (isNaN(result)) return 0;
        return result;

    }

    static isString = function (str: any) {
        if (typeof str === 'string' || str instanceof String) {
            return true;
        }
        return false;
    }

    static isInvalidAFRRoute = function (path: string) {
        var validRoutes = [{ path: "/EntityAFRManagementA" },
        { path: "/EntityAFRManagement" },
        { path: "/AfrSummaryA" },
        { path: "/AfrSummary" },
        { path: "/AfrDataImport" },
        { path: "/AfrDataImportA" },
        { path: "/BalanceSheet" },
        { path: "/BalanceSheetA" },
        { path: "/Revenues" },
        { path: "/RevenuesA" },
        { path: "/Expenditures" },
        { path: "/ExpendituresA" },
        { path: "/AccountsByGovernmentalA" },
        { path: "/AccountsByProprietaryA" },
        { path: "/AccountsByFiduciaryA" },
        { path: "/AccountsByComponentUnitsA" },
        { path: "/AccountsByGovernmental" },
        { path: "/AccountsByProprietary" },
        { path: "/AccountsByFiduciary" },
        { path: "/AccountsByComponentUnits" },
        { path: "/LongTermDebt" },
        { path: "/LongTermDebtA" },
        { path: "/AfrData" },
        { path: "/AfrDataA" },
        { path: "/AffiliatedEntities" },
        { path: "/AffiliatedEntitiesA" },
        { path: "/Audit" },
        { path: "/AuditA" },
        { path: "/Certification" },
        { path: "/CertificationA" },
        { path: "/AfrReports" },
        { path: "/AfrReportsA" },
        { path: "/CR939ReportsA" },
        { path: "/CR939Reports" },
        { path: "/CourtReporting939CIA" },
        { path: "/CourtReporting939CI" },
        { path: "/CourtReporting939LLA" },
        { path: "/CourtReporting939LL" },
        { path: "/CourtReporting939LAPA" },
        { path: "/CourtReporting939LAP" },
        { path: "/CourtReporting939JAPA" },
        { path: "/CourtReporting939JAP" },
        { path: "/CourtReporting939ImportExport" },
        { path: "/CourtReporting939ImportExportA" },
        { path: "/CourtReporting939Summary" },
        { path: "/CourtReporting939SummaryA" },
        { path: "/CourtReporting939Admin" },
        { path: "/CourtReporting939AdminA" },
        { path: "/CR939ErrorsA" },
        { path: "/CR939Errors" },
        { path: "/CR29AdminA" },
        { path: "/CR29Admin" },
        { path: "/CR29DataAA" },
        { path: "/CR29DataA" },
        { path: "/CR29DataBA" },
        { path: "/CR29DataB" },
        { path: "/CR29DataCA" },
        { path: "/CR29DataC" },
        { path: "/CR29DataDA" },
        { path: "/CR29DataD" },
        { path: "/CR29DataEA" },
        { path: "/CR29DataE" },
        { path: "/CR29CertificationA" },
        { path: "/CR29Certification" },
        { path: "/CR29ReportsA" },
        { path: "/CR29Reports" },
        { path: "/CR29ErrorsA" },
        { path: "/CR29Errors" },
        { path: "/InstructionsA" },
        { path: "/Instructions" },
        { path: "/Errors" },
        { path: "/ErrorsA" },];
        var index = validRoutes.findIndex(x => x.path === path);

        if (index === -1) {
            return true;
        }
        return false;
    }

    static isValidAFRRouteForErrorHandler = function (path: string) {
        var validRoutes = [
            { path: "/AfrSummaryA" },
            { path: "/AfrSummary" },
            { path: "/AfrDataImport" },
            { path: "/AfrDataImportA" },
            { path: "/BalanceSheet" },
            { path: "/BalanceSheetA" },
            { path: "/Revenues" },
            { path: "/RevenuesA" },
            { path: "/Expenditures" },
            { path: "/ExpendituresA" },
            { path: "/AccountsByGovernmentalA" },
            { path: "/AccountsByProprietaryA" },
            { path: "/AccountsByFiduciaryA" },
            { path: "/AccountsByComponentUnitsA" },
            { path: "/AccountsByGovernmental" },
            { path: "/AccountsByProprietary" },
            { path: "/AccountsByFiduciary" },
            { path: "/AccountsByComponentUnits" },
            { path: "/LongTermDebt" },
            { path: "/LongTermDebtA" },
            { path: "/AfrData" },
            { path: "/AfrDataA" },
            { path: "/AffiliatedEntities" },
            { path: "/AffiliatedEntitiesA" },
            { path: "/Audit" },
            { path: "/AuditA" },
            { path: "/Certification" },
            { path: "/CertificationA" },
            { path: "/AfrReports" },
            { path: "/AfrReportsA" },
            { path: "/CR939ReportsA" },
            { path: "/CR939Reports" },
            { path: "/CourtReporting939CIA" },
            { path: "/CourtReporting939CI" },
            { path: "/CourtReporting939LLA" },
            { path: "/CourtReporting939LL" },
            { path: "/CourtReporting939LAPA" },
            { path: "/CourtReporting939LAP" },
            { path: "/CourtReporting939JAPA" },
            { path: "/CourtReporting939JAP" },
            { path: "/CourtReporting939Summary" },
            { path: "/CourtReporting939SummaryA" },
            { path: "/CourtReporting939Admin" },
            { path: "/CourtReporting939AdminA" },
            { path: "/CR939ErrorsA" },
            { path: "/CR939Errors" },
            { path: "/CR29AdminA" },
            { path: "/CR29Admin" },
            { path: "/CR29DataAA" },
            { path: "/CR29DataA" },
            { path: "/CR29DataBA" },
            { path: "/CR29DataB" },
            { path: "/CR29DataCA" },
            { path: "/CR29DataC" },
            { path: "/CR29DataDA" },
            { path: "/CR29DataD" },
            { path: "/CR29DataEA" },
            { path: "/CR29DataE" },
            { path: "/CR29CertificationA" },
            { path: "/CR29Certification" },
            { path: "/CR29ReportsA" },
            { path: "/CR29Reports" },
            { path: "/CR29ErrorsA" },
            { path: "/CR29Errors" },
            { path: "/InstructionsA" },
            { path: "/Instructions" },
            { path: "/Errors" },
            { path: "/ErrorsA" },];


        var index = validRoutes.findIndex(x => x.path === path);

        if (index > -1) {
            return true;
        }
        return false;
    }

    static isBlockedNavigation = function (path: string, isDirty: boolean) {
        if (utilityHelper.isInvalidAFRRoute(path) && isDirty) {
            return true;
        }

        return false;
    }

    static isDEWEmpty = function (afr: Afr) {
        var returnValue = true;

        if (afr) {
            const tableId = getTable(afr, enums.tableName.dew);
            if (!(tableId)) { return true; }

            var countFact = 0
            for (var row of tableId.rows) {
                var fact = getFact(row, "period");

                if (fact) {
                    countFact = countFact + 1;
                }
            }
            if (tableId.rows.length === countFact) {
                returnValue = false;
            }
        }

        return returnValue;
    }

    static collectMissingDEWEntries = function (afr: Afr): string[] {

        var missingAccounts: string[] = [];
        if (afr) {
            const tableId = getTable(afr, enums.tableName.dew);
            if (!(tableId)) { return []; }

            var countFact = 0
            for (var row of tableId.rows) {
                var fact = getFact(row, "period");

                if (fact) {
                    countFact = countFact + 1;
                } else if (row.account) {
                    missingAccounts.push(row.account.name);
                }
            }
            if (tableId.rows.length === countFact) {
                return [];
            }
        }

        return missingAccounts;
    }

    static isAuditEmpty = function (audit: Audit | null) {
        var returnValue = true;
        if (audit) {
            if ((audit.datePerformed && audit.datePerformed.length > 0) && audit.auditorReference && (audit.auditPdf || (audit.sendAuditPdf ? true : false))) {
                if (audit.auditType === "DEW") { return true; }
                returnValue = false;
            }
        }
        return returnValue;
    }

    static isAuditIncomplete = function (audit: Audit) {

        var meetCondition = 0;
        if (audit) {
            if ((audit.datePerformed && audit.datePerformed.length > 0)) {
                meetCondition = meetCondition + 1;
            }
            if (audit.auditorReference) {
                meetCondition = meetCondition + 1;
            }
            if (audit.auditPdf || audit.sendAuditPdf) {
                meetCondition = meetCondition + 1;
            }

            if (meetCondition > 0 && meetCondition < 3) {
                return true;
            }

        }
        return false;
    }

    static isAuditDatePerformedSatisfied = function (audit: Audit) {

        if (audit === null) {
            return { isValid: false, message: "The audit completion date is required." }
        }


        if (audit.datePerformed === null || audit.datePerformed.length === 0) {
            return { isValid: false, message: "The audit completion date is required." }
        }

        if (audit.datePerformed) {
            if (dateHelper.convertToDate(audit.datePerformed) === null) {
                return { isValid: false, message: "The audit completion date is not valid." }
            }

            if (dateHelper.IsDateInFuture(audit.datePerformed)) {
                return { isValid: false, message: "The audit completion date cannot be a future date." }
            }
        }


        return { isValid: true, message: "" }
    }

    static isAuditorSatisfied = function (audit: Audit) {

        if (audit) {
            if (audit.auditorReference === null) {
                return false;
            }
        }
        return true;
    }

    static isAuditPDFSatisfied = function (audit: Audit) {

        if (audit) {
            if (audit.auditPdf || (audit.sendAuditPdf ? true : false)) {
                return true;
            }
        }
        return false;
    }

    static isCR29CertificationReady = function (afr: Afr, errorMessage: Array<AFRError>): boolean {
        var returnValue = false;
        // First check to see if we have the signed document
        if (!afr.currentversion) {
            return false;
        }
        if (afr.currentversion.documents) {
            var signed = afr.currentversion.documents.find(x => x.role.toLowerCase().indexOf("signed") >= 0);
            if (signed) {
                // If we have a signed document we don't need the certification
                return true;
            }
        }
        var cert: Certification = afr.currentversion.certification;
        if (cert.firstCertifier) {
            if (cert.firstCertifier.name.length > 0 &&
                cert.firstCertifier.title.length > 0) {

                if (!cert.firstCertifier.contactInfo || !cert.firstCertifier.contactInfo.number || cert.firstCertifier.contactInfo.number.number.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifier Phone Number is required to certify this Court Report 29.0085.", "", "", errorMessage);
                } else {
                    returnValue = true;
                }

            } else {
                if (cert.firstCertifier.name.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifier Name is required to certify this Court Report 29.0085.", "", "", errorMessage);
                }
                if (cert.firstCertifier.title.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifier Title is required to certify this Court Report 29.0085.", "", "", errorMessage);
                }
                if (!cert.firstCertifier.contactInfo || !cert.firstCertifier.contactInfo.number || cert.firstCertifier.contactInfo.number.number.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifier Phone Number is required to certify this Court Report 29.0085.", "", "", errorMessage);
                }
            }
        } else {
            if (cert.firstCertifier === null) {
                if (afr.currentversion.documents) {
                    var signed = afr.currentversion.documents.find(x => x.role.toLowerCase().indexOf("signed") >= 0);
                    if (signed) {
                        // We have a signed document we don't need the certification
                        return returnValue;
                    }
                }
                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifier Information is required to certify this Court Report 29.0085.", "", "", errorMessage);
            }
        }
        return returnValue;
    }

    static isAfrCertificationReady = function (afr: Afr, errorMessage: Array<AFRError>): boolean {
        var returnValue = false;
        var cert: Certification = afr.currentversion.certification;
        if (cert.firstCertifier && cert.secondCertifier) {
            if (cert.firstCertifier.name.length > 0 &&
                cert.firstCertifier.title.length > 0 &&
                cert.secondCertifier.name.length > 0 &&
                cert.secondCertifier.title.length > 0) {

                returnValue = true;
            } else {
                if (cert.firstCertifier.name.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The First Certifier Name is required to certify this AFR.", "", "", errorMessage);
                }
                if (cert.firstCertifier.title.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The First Certifier Title is required to certify this AFR.", "", "", errorMessage);
                }
                if (cert.secondCertifier.name.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Second Certifier Name is required to certify this AFR.", "", "", errorMessage);
                }
                if (cert.secondCertifier.title.length === 0) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Second Certifier Title is required to certify this AFR.", "", "", errorMessage);
                }
            }
        } else {
            if (cert.firstCertifier === null) {
                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The First Certifier Information is required to certify this AFR.", "", "", errorMessage);
            }
            if (cert.secondCertifier === null) {
                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Second Certifier Information is required to certify this AFR.", "", "", errorMessage);
            }
        }
        return returnValue;
    }


    static isCertificationReady = function (afr: Afr, errorMessage: Array<AFRError>): boolean {
        var returnValue = false;
        if (afr && afr.currentversion && afr.currentversion.certification) {
            if (afr.taxonomyType) {
                switch (afr.taxonomyType) {
                    case TaxonomyTypeEnum.AFR:
                        returnValue = utilityHelper.isAfrCertificationReady(afr, errorMessage);
                        break;

                    case TaxonomyTypeEnum.COURT_REPORTING_29:
                        returnValue = utilityHelper.isCR29CertificationReady(afr, errorMessage);
                        break;

                    default:
                        returnValue = true;
                        break;
                }
            }
        } else {
            if (afr && afr.currentversion && afr.currentversion.certification === null) {
                switch (afr.taxonomyType) {
                    case TaxonomyTypeEnum.AFR:
                        utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifiers Information is required to certify this AFR.", "", "", errorMessage);
                        break;

                    case TaxonomyTypeEnum.COURT_REPORTING_29:
                        if (afr.currentversion.documents) {
                            var signed = afr.currentversion.documents.find(x => x.role.toLowerCase().indexOf("signed") >= 0);
                            if (signed) {
                                // We have a signed document we don't need the certification
                                return true;
                            }
                        }
                        utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Certifier Information is required to certify this Court Report 29.0085.", "", "", errorMessage);
                        break;

                    default:
                        returnValue = true;
                        break;
                }
            }
        }

        return returnValue;
    }

    static getSectionError(table: string) {
        switch (table) {
            case enums.tableName.balanceSheet:
                return { section: enums.UISection.balanceSheet, tab: enums.UISection.balanceSheet };
            case enums.tableName.expenditures:
                return { section: enums.UISection.expenditures, tab: enums.UISection.expenditures };
            case enums.tableName.revenues:
                return { section: enums.UISection.revenues, tab: enums.UISection.revenuesRevenuesTab };
            case enums.tableName.impactfees:
                return { section: enums.UISection.revenues, tab: enums.UISection.revenuesImpactFeesTab };
            case enums.tableName.affiliatedEntity:
                return { section: enums.UISection.affiliatedEntities, tab: enums.UISection.affiliatedEntities };
            default:
                return { section: "", tab: "" };
        }
    }

    static removeErrorsInSection(errorList: Array<ErrorSummaryAFRSection>, section: string, dispatch: any) {

        var globalErrors: Array<ErrorSummaryAFRSection> = JSON.parse(JSON.stringify(errorList));

        var index = globalErrors.findIndex(x => x.section.sectionCode === section);
        if (index > -1) {
            // Delete the section into the error list
            globalErrors.splice(index, 1);

            // save in redux
            dispatch(updateErrors(globalErrors));
        }
    }

    static notifyErrors(afr: Afr, section: string, errors: Array<AFRError>, dispatch: any) {

        /* get error list */
        const errorList: Array<ErrorSummaryAFRSection> = dispatch(getSelector(getErrorList));

        /*  get section errors */
        var sectionErrors: ErrorSummaryAFRSection = addBusinessRulesErrors(afr, utilityHelper.getSection(section, afr.taxonomyType), errors);
        var globalErrors: Array<ErrorSummaryAFRSection> = JSON.parse(JSON.stringify(errorList));

        //order the table by account
        const orderBySectionAsc = function compare(a: ErrorSummaryAFRSection, b: ErrorSummaryAFRSection) {
            if (a.section.sectionCode < b.section.sectionCode) {
                return -1;
            }
            if (a.section.sectionCode > b.section.sectionCode) {
                return 1;
            }
            return 0;
        }


        /* merge errors */
        var index = globalErrors.findIndex(x => x.section.sectionCode === section);
        if (index === -1) {
            if (errors.length > 0) {
                globalErrors.push(sectionErrors);
                globalErrors.sort(orderBySectionAsc);
                dispatch(updateErrors(globalErrors));
                return;
            }
        } else {
            /* remove previous business rule errors  */
            var errorSection = globalErrors[index];
            var filter: Array<AFRError> = errorSection.errorList.filter(x => (x.type !== enums.errorType.sectionRuleEvaluator));

            /* append the business rules error found in this section */
            for (var err of errors) {
                filter.push(err);
            }

            var oldErrors: Array<AFRError> = [];
            var newErrors: Array<AFRError> = [];

            if (errorSection.errorList) {
                oldErrors = errorSection.errorList;
            }
            if (filter && filter.length > 0) {
                newErrors = filter;
            }

            globalErrors[index].errorList = newErrors;
            globalErrors[index].sectionErrorCount = filter.length;

            if (filter.length === 0) {
                globalErrors.splice(index, 1);
            }
            /* when previous errors are different to current errors int he section then the new errors must be saved to redux */
            var errorsChanged = !utilityHelper.isEqualObject(oldErrors, newErrors);

            globalErrors.sort(orderBySectionAsc);
            /* update errors in redux if there is a change in the errors */
            /* this check is to avoid saving infinitely in redux when the errors have not changed */
            if (errorsChanged) {
                dispatch(updateErrors(globalErrors));
            }
        }

    }

    static isDonePrimaryDataEntry(afr: Afr | null, entity: Entity | null) : boolean {
        if (!afr || !entity) {
            return true;
        }
        if (isFundGroupOriented(afr)) {
            if (afr.affiliateReporting && afr.affiliateReporting.length > 0) {
                return (utilityHelper.isDone(afr, enums.UISection_FundGroup.governmentalFunds, entity)
                    && utilityHelper.isDone(afr, enums.UISection_FundGroup.proprietaryFunds, entity)
                    && utilityHelper.isDone(afr, enums.UISection_FundGroup.fiduciaryFunds, entity)
                    && utilityHelper.isDone(afr, enums.UISection_FundGroup.componentUnitsFunds, entity)
                );
            } else {
                return (utilityHelper.isDone(afr, enums.UISection_FundGroup.governmentalFunds, entity)
                    && utilityHelper.isDone(afr, enums.UISection_FundGroup.proprietaryFunds, entity)
                    && utilityHelper.isDone(afr, enums.UISection_FundGroup.fiduciaryFunds, entity)
                );
            }
        }
        if (afr.year >= 2022 && !utilityHelper.isDone(afr, enums.UISection.balanceSheet, entity)) {
            return false;
        }
        return (utilityHelper.isDone(afr, enums.UISection.expenditures, entity)
            && utilityHelper.isDone(afr, enums.UISection.revenues, entity)            
        );
    }
    static getWorkStateNameList(shortNameList: string[]): string[] {
        var results: string[] = [];
        shortNameList.map(s => {
            if (enums.noDataWorkStateName.hasOwnProperty(s)) {
                results.push(enums.noDataWorkStateName[s]);
            }
            if (enums.doneWorkStateName.hasOwnProperty(s)) {
                results.push(enums.doneWorkStateName[s]);
            }
        });
        return results;
    }
    static isDoneByAccountGroups(afr: Afr, section : string ) : boolean {
        const stateDoneOrNo = generateLocalStateFromEventProperties(afr, utilityHelper.getWorkStateNameList(["balanceSheet", "revenues", "expenditures"]));


        var eventDone = false;
        switch (section) {
            case enums.UISection.balanceSheet:
                /* Evaluate first if the section is required for this year */
                if (stateDoneOrNo["workState_noBalanceSheet"]) {
                    eventDone = true;
                } else {
                    eventDone = existFactsInTable(afr, [enums.tableName.balanceSheet]);
                }
                break;
            case enums.UISection.revenues:
                eventDone = (stateDoneOrNo["workState_revenuesComplete"] ? true : false);
                break;
            case enums.UISection.expenditures:
                eventDone = (stateDoneOrNo["workState_expendituresComplete"] ? true : false);
                break;
        }
        return eventDone;
    }
    static isDoneByFundGroups(afr: Afr, section: string) : boolean {
        const stateDoneOrNo = generateLocalStateFromEventProperties(afr, utilityHelper.getWorkStateNameList([
            "governmental",
            "proprietary",
            "fiduciary",
            "units"]));
        var sectKey = enums.UISectionName[section];
        var doneKey = enums.doneWorkStateName[sectKey];
        if (stateDoneOrNo.hasOwnProperty(doneKey)) {
            var doneState: boolean | null = stateDoneOrNo[doneKey];
            if (!doneState) {
                return false;
            }
            return doneState;
        }
        // Default if the key is not part of our state map is to return true.
        return true;
    }
    static getDoneStateByAccountGroups(afr: Afr): string {
        const stateDoneOrNo = generateLocalStateFromEventProperties(afr, utilityHelper.getWorkStateNameList(["balanceSheet", "revenues", "expenditures"]));


        var eventDoneState : string[] = [];
        if (stateDoneOrNo["workState_noBalanceSheet"]) {
            eventDoneState.push("1");
        } else {
            eventDoneState.push(existFactsInTable(afr, [enums.tableName.balanceSheet]) ? "1":"0");
        }
        eventDoneState.push((stateDoneOrNo["workState_revenuesComplete"] ? "1" : "0"));
        eventDoneState.push((stateDoneOrNo["workState_expendituresComplete"] ? "1" : "0"));
        return eventDoneState.join("");
    }
    static getDoneStateByFundGroups(afr: Afr): string {
        const stateDoneOrNo = generateLocalStateFromEventProperties(afr, utilityHelper.getWorkStateNameList([
            "governmental",
            "proprietary",
            "fiduciary",
            "units"]));
        var eventDoneState: string[] = [];
        for (var section of ["14", "15", "16", "17"]) {
            var sectKey = enums.UISectionName[section];
            var doneKey = enums.doneWorkStateName[sectKey];
            if (stateDoneOrNo.hasOwnProperty(doneKey)) {
                var doneState: boolean | null = stateDoneOrNo[doneKey];
                if (!doneState) {
                    eventDoneState.push("0");
                } else {
                    eventDoneState.push(doneState ? "1" : "0");
                }
            }
        }
        return eventDoneState.join("");
    }
    static isDone(afr: Afr | null, section: string, entity: Entity | null) {
        if (!(afr)) { return true; }
        if (!(entity)) { return true; }

        var eventDone = isFundGroupOriented(afr) ? utilityHelper.isDoneByFundGroups(afr, section) : utilityHelper.isDoneByAccountGroups(afr, section);
        var isSectionRequired = utilityHelper.isSectionRequired(section, afr, entity);

        if (!isSectionRequired) {
            return true;
        }

        if (utilityHelper.checkStatusList(afr, enums.verifiedCertifiedRecertified)) {
            return true;
        }
        let flag: boolean = eventDone;
        return flag ? flag : false;
    }

    static isNoData(afr: Afr | null, section: string, entity: Entity | null) {
        if (!(afr)) { return true; }
        if (!(entity)) { return true; }

        const stateNoData = generateLocalStateFromEventProperties(afr, [
            "workState_noBalanceSheet",
            "workState_noExpenditures",
            "workState_noRevenues",
            "workState_noConstructionProjects",
            "workState_noBonds"
        ]);

        var eventNoData = false;
        var isSectionRequired = utilityHelper.isSectionRequired(section, afr, entity);

        switch (section) {
            case enums.UISection.balanceSheet:
                /* Evaluate first if the section is required for this year */
                if (stateNoData["workState_noBalanceSheet"]) {
                    eventNoData = true;
                }
                break;
            case enums.UISection.revenues:
                if (stateNoData["workState_noRevenues"]) {
                    eventNoData = true;
                }
                break;
            case enums.UISection.expenditures:
                if (stateNoData["workState_noExpenditures"]) {
                    eventNoData = true;
                }
                break;
            case enums.UISection.otherAfrDataProjects:
                if (stateNoData["workState_noConstructionProjects"]) {
                    eventNoData = true;
                }
                break;
            case enums.UISection.otherAfrDataBonds:
                if (stateNoData["workState_noBonds"]) {
                    eventNoData = true;
                }
                break;
        }
        return eventNoData;
    }

    static evaluateSectionOK = function (user: logerUser | null, afr: Afr, entity: Entity | null, section: string, auditMessage: AuditMessage, errorMessage: Array<AFRError>, dispatch: any): string {

        var factValue: string;
        if (utilityHelper.checkStatusList(afr, enums.verifiedCertifiedRecertified)) {
            return "";
        }
        if (afr.taxonomyType && (afr.taxonomyType === TaxonomyTypeEnum.COURT_REPORTING_939 || afr.taxonomyType === TaxonomyTypeEnum.COURT_REPORTING_29)) {
            if (afr.status === enums.AFRStatus.not_reported) {
                return "";
            }
        }
        if (!entity) {
            return "";
        }
        switch (section) {
            case enums.UISection.summary:
                if (afr.taxonomyType && afr.taxonomyType !== TaxonomyTypeEnum.COURT_REPORTING_29) {
                    return "";
                }
                if (afr.currentversion && afr.currentversion.documents && afr.currentversion.documents.length > 0) {
                    return "OK";
                }
                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "A CPA letter must be uploaded", "", "", errorMessage);
                return "";

            case enums.UISection.reports:
            case enums.UISection.errors:
            case enums.UISection.importAfrData:
                return "";
            case enums.UISection.balanceSheet:
                if (utilityHelper.isDone(afr, section, entity)) {
                    return "OK";
                }
                var factRef: ErrorFactReference = {
                    dimensions: [{
                        axis: "AfrNoDataAxis",
                        member: "AFRND_BalanceSheetMember",
                        typedContent: null
                    }],
                    concept: { id: "AFRND_NoData" },
                    value: 0,
                    textValue: null
                }
                utilityHelper.addErrorIfNotFlagged(afr, enums.errorType.sectionRuleEvaluator, enums.severity.warning, "If there are no Balance Sheet facts the 'No Balance Sheet' box must be checked", "", "", errorMessage, factRef);
                return "";
            case enums.UISection.revenues:
                if (utilityHelper.isDone(afr, section, entity)) {
                    return "OK";
                }
                var factRef: ErrorFactReference = {
                    dimensions: [{
                        axis: "AfrNoDataAxis",
                        member: "AFRND_RevenuesMember",
                        typedContent: null
                    }],
                    concept: { id: "AFRND_NoData" },
                    value: 0,
                    textValue: null
                }
                utilityHelper.addErrorIfNotFlagged(afr, enums.errorType.sectionRuleEvaluator, enums.severity.warning, "The 'Done' box must be checked if this section is completed.", "", "", errorMessage, factRef);
                return "";

            case enums.UISection.expenditures:
                if (utilityHelper.isDone(afr, section, entity)) {
                    return "OK";
                }
                var factRef: ErrorFactReference = {
                    dimensions: [{
                        axis: "AfrNoDataAxis",
                        member: "AFRND_ExpendituresMember",
                        typedContent: null
                    }],
                    concept: { id: "AFRND_NoData" },
                    value: 0,
                    textValue: null
                }
                utilityHelper.addErrorIfNotFlagged(afr, enums.errorType.sectionRuleEvaluator, enums.severity.warning, "The 'Done' box must be checked if this section is completed.", "", "", errorMessage,factRef);
                return "";

            case enums.UISection_FundGroup.governmentalFunds:
            case enums.UISection_FundGroup.proprietaryFunds:
            case enums.UISection_FundGroup.fiduciaryFunds:
            case enums.UISection_FundGroup.componentUnitsFunds:
                if (utilityHelper.isDone(afr, section, entity)) {
                    return "OK";
                }
                return "";

            case enums.UISection.longTermDebt:
                factValue = utilityHelper.getFactValue(afr, enums.tableName.longTermDebt, enums.rowCode.longTermDebtAmount);
                if (factValue) { return "OK" }
                var factRef: ErrorFactReference = {
                    dimensions: [],
                    concept: { id: "LongTermDebt" },
                    value: 0,
                    textValue: null
                }

                utilityHelper.addErrorIfNotFlagged(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "Long-Term Debt is required.", "", "", errorMessage,factRef);
                return "";
            case enums.UISection.otherAfrData:
                return utilityHelper.isSupplementaryDataSatisfied(afr, entity, errorMessage);
            case enums.UISection.affiliatedEntities:
                return utilityHelper.isAffiliatedEntitySatisfied(afr, errorMessage, dispatch);
            case enums.UISection.audit:
                return utilityHelper.isAuditSatisfied(afr, entity, auditMessage, errorMessage);
            case enums.UISection.certification:
                if (user && entity && getAuthorization(user, entity.code) === UserEntityAuthorizationEnum.ThirdParty) {
                    return "OK";
                }
                if (utilityHelper.isCertificationReady(afr, errorMessage)) { return "OK"; }
                return "";
            case enums.UISection_CR29.CR29PartA:
            case enums.UISection_CR29.CR29PartB:
            case enums.UISection_CR29.CR29PartC:
            case enums.UISection_CR29.CR29PartD:
            case enums.UISection_CR29.CR29PartE:
                return "OK";
            case enums.UISection_CR939.courtInnovations:
            case enums.UISection_CR939.legalAidProgram:
            case enums.UISection_CR939.lawLibrary:
            case enums.UISection_CR939.juvenileAlternativeProgram:
                return "OK";
            case enums.UISection_CR939.dataSummary:
                return "";

        }
        return "";

    }

    /* check if supplementary data is satisfied */
    static isSupplementaryDataSatisfied(afr: Afr, entity: Entity | null, errorMessage: Array<AFRError>) {
        var errorCount = 0;
        /* check if Exceptions or Waivers were't uploaded */
        /* when impact fees reported then upload affidavit is mandatory */
        if (utilityHelper.isDone(afr, enums.UISection.revenues, entity)) {
            var isExceptionsUploaded = utilityHelper.isExceptionsUploaded(afr);
            var isWaiversUploaded = utilityHelper.isWaiversUploaded(afr);
            if (!(isExceptionsUploaded && isWaiversUploaded)) {
                if (!isExceptionsUploaded) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Impact Fee Exceptions document must be uploaded or 'I have no Exceptions' option must be selected", "", "", errorMessage);
                }
                if (!isWaiversUploaded) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "The Impact Fee Waivers document must be uploaded or 'I have no Waivers' option must be selected", "", "", errorMessage);
                }
                errorCount = errorCount + 1;
            }

            /* Is affidavit required for this year? */
            if (utilityHelper.isAffidavitRequired(afr)) {
                if ((utilityHelper.getImpactFeesTotal(afr) !== 0 && !(utilityHelper.isAffidavtUploaded(afr)))) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.warning, "Local Governments who report Impact Fees must upload an affidavit signed by its chief financial officer", "", "", errorMessage);
                    errorCount = errorCount + 1;
                }
            }

        } else {
            return ""
        }
        if (errorCount > 0) {
            return "";
        }
        return "OK";
    }

    static isAffidavitRequired(afr: Afr | null) {

        if (afr) {
            if (afr.year >= 2021) {
                return true;
            }
        }
        return false;
    }
    static matchesDimension = function (dm: DimensionReference, edr: DimensionIdReference): boolean {
        if (dm.axis.id !== edr.axis) {
            return false;
        }
        if (!dm.member) {
            return false;
        }
        if (dm.member.id !== edr.member) {
            if (dm.member.code && dm.member.code === edr.member) {
                return true;
            }
            return false;
        }
        return true;
    }
    static matchesErrorSpec = function (f: Fact, efr: ErrorFactReference) : boolean {
        if (!f.concept) {
            return false;
        }
        if (f.concept.id !== efr.concept.id) {
            return false;
        }
        if (efr.dimensions && efr.dimensions.length > 0) {
            if (!f.dimensions || f.dimensions.length == 0) {
                return false;
            }
            var dimMatches : any[] = [];
            efr.dimensions.map(x => f.dimensions.map(y => utilityHelper.matchesDimension(y, x) ? dimMatches.push(y) : ""));
            if (dimMatches.length < efr.dimensions.length) {
                return false;
            }
        }
        if (efr.textValue != null) {
            if (!f.textValue || f.textValue !== efr.textValue) {
                return false;
            }
        }
        return true;
    }
    static addErrorIfNotFlagged(afr: Afr, type: string, severity: number, message: string, entityType: string, entityCode: string, errors: Array<AFRError>, errorFactReference : ErrorFactReference | null ) {

        if (afr.status === enums.AFRStatus.not_reported) {
            return;
        }
        if (afr.afrId == null) {
            return;
        }
        if (afr.currentversion == null) {
            return;
        }
        if (errorFactReference && afr.currentversion.missingFacts && afr.currentversion.missingFacts.length > 0) {
            var errorFact = afr.currentversion.missingFacts.find(x => utilityHelper.matchesErrorSpec(x, errorFactReference));
            if (errorFact != null) {
                return;
            }
        }
        var timeStamp = new Date().toISOString();
        timeStamp = dateHelper.stringDateInFormat(timeStamp, "yyy-LL-ddTHH:mm");

        const error: AFRError = {
            type: type,
            description: message,
            severity: severity,
            linkTo: "",
            entityId: afr.afrId.split("^")[0],
            affiliateId: null,
            year: afr.year.toString(),
            timeStamp: timeStamp,
            entityType: entityType,
            entityCode: entityCode,
        }

        errors.push(error);
    }

    static addError(afr: Afr, type: string, severity: number, message: string, entityType: string, entityCode: string, errors: Array<AFRError>) {
        utilityHelper.addErrorIfNotFlagged(afr, type, severity, message, entityType, entityCode, errors, null);
    }

    /*returns true if equal */
    static isEqualObject(obj1: any, obj2: any) {
        return (JSON.stringify(obj1) === JSON.stringify(obj2));
    }


    static getSection(section: string, tt: TaxonomyTypeEnum | null): Section {
        var ttPrefix = "/";
        switch (tt) {
            case TaxonomyTypeEnum.COURT_REPORTING_29:
                ttPrefix += "CR29";
                break;
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                ttPrefix += "CR939";
                break;
        }
        switch (section) {
            case enums.UISection.summary:
                var sumPath = "";
                switch (tt) {
                    case TaxonomyTypeEnum.COURT_REPORTING_29:
                        sumPath = "/CR29AdminA";
                        break;

                    case TaxonomyTypeEnum.COURT_REPORTING_939:
                        sumPath = "/CourtReporting939AdminA";
                        break;

                    default:
                        sumPath = "/AfrSummaryA";
                        break;
                }
                return {
                    sectionCode: enums.UISection.summary,
                    sectionPage: sumPath,
                    sectionTitle: "Summary",
                    sectionIsOpen: false,
                }
            case enums.UISection.importAfrData:
                return {
                    sectionCode: enums.UISection.importAfrData,
                    sectionPage: "/AfrDataImportA",
                    sectionTitle: "Import AFR Data",
                    sectionIsOpen: false,
                }
            case enums.UISection.balanceSheet:
                return {
                    sectionCode: enums.UISection.balanceSheet,
                    sectionPage: "/BalanceSheetA",
                    sectionTitle: "Balance Sheet",
                    sectionIsOpen: false,
                }
            case enums.UISection.revenues:
                return {
                    sectionCode: enums.UISection.revenues,
                    sectionPage: "/RevenuesA",
                    sectionTitle: "Revenues",
                    sectionIsOpen: false,
                }
            case enums.UISection.expenditures:
                return {
                    sectionCode: enums.UISection.expenditures,
                    sectionPage: "/ExpendituresA",
                    sectionTitle: "Expenditures",
                    sectionIsOpen: false,
                }
            case enums.UISection.longTermDebt:
                return {
                    sectionCode: enums.UISection.longTermDebt,
                    sectionPage: "/LongTermDebtA",
                    sectionTitle: "Long-Term Debt",
                    sectionIsOpen: false,
                }
            case enums.UISection.otherAfrData:
                return {
                    sectionCode: enums.UISection.otherAfrData,
                    sectionPage: "/AfrDataA",
                    sectionTitle: "Supplemental Info",
                    sectionIsOpen: false,
                }
            case enums.UISection.affiliatedEntities:
                return {
                    sectionCode: enums.UISection.affiliatedEntities,
                    sectionPage: "/AffiliatedEntitiesA",
                    sectionTitle: "Affiliated Entities",
                    sectionIsOpen: false,
                }
            case enums.UISection.audit:
                return {
                    sectionCode: enums.UISection.audit,
                    sectionPage: "/AuditA",
                    sectionTitle: "Audit",
                    sectionIsOpen: false,
                }
            case enums.UISection.certification:
                return {
                    sectionCode: enums.UISection.certification,
                    sectionPage: ttPrefix + "CertificationA",
                    sectionTitle: "Certification",
                    sectionIsOpen: false,
                }
            case enums.UISection.errors:
                return {
                    sectionCode: enums.UISection.errors,
                    sectionPage: ttPrefix + "ErrorsA",
                    sectionTitle: "Errors",
                    sectionIsOpen: false,
                }
        }

        return {
            sectionCode: "",
            sectionPage: "",
            sectionTitle: "",
            sectionIsOpen: false,
        }

    }

    static getDoneSectionNames(currentAfr: Afr | null, entity: Entity | null) : string {
        if (!currentAfr || currentAfr.year < 2022) {
            return "both the Revenues and Expenditures pages.";
        }
        if (!isFundGroupOriented(currentAfr)) {
            return "the Balance Sheet, Revenues and Expenditures pages.";
        }
        var sectionsToTest: string[] = [
            enums.UISection_FundGroup.governmentalFunds,
            enums.UISection_FundGroup.proprietaryFunds,
            enums.UISection_FundGroup.fiduciaryFunds
        ];
        if (hasDiscreteAffiliates(currentAfr)) {
            sectionsToTest.push(enums.UISection_FundGroup.componentUnitsFunds);
        }
        var sectionsNotDone: string[] = [];
        for (var section of sectionsToTest) {
            if (!utilityHelper.isDone(currentAfr, section, entity)) {
                sectionsNotDone.push(enums.UISectionDisplayName[section]);
            }
        }
        var result = "the ";
        switch (sectionsNotDone.length) {
            case 0:
                break;

            case 1:
                result += sectionsNotDone[0] + " page.";
                break;

            case 2:
                result += sectionsNotDone[0] + " and " + sectionsNotDone[1] + " pages.";
                break;

            case 3:
                result += sectionsNotDone[0] + ", " + sectionsNotDone[1] + " and " + sectionsNotDone[2] + " pages.";
                break;

            case 4:
                result += sectionsNotDone[0] + ", " + sectionsNotDone[1] + ", " + sectionsNotDone[2] + " and " + sectionsNotDone[3] + " pages.";
                break;
        }
        return result;
    }

    /* check if an audit is satisfied  */
    static isAuditSatisfied(afr: Afr | null, entity: Entity | null, auditMessage: AuditMessage, errorMessage: Array<AFRError>) {
        var audit: Audit | null = null;

        if (!(afr && entity)) {
            return "";
        }
        var entityName: string = entity.name;
        if (!utilityHelper.isDonePrimaryDataEntry(afr, entity)) {
            utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.warning,
                entityName + ' must finish entering all the required values. Please ensure the "Done" box is checked on ' + utilityHelper.getDoneSectionNames(afr, entity),
                "", "", errorMessage);
            return "";
        }

        if (afr.currentversion && afr.currentversion.audit) { audit = afr.currentversion.audit }
        if (!audit) {
            if (auditMessage.requireAudit) {
                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, `This AFR requires an audit.`, "", "", errorMessage);
                return "";
            }
            if (isFundGroupOriented(afr)) {
                // No need for a message, once the Afr is saved with no audit (DEW or otherwise) then the appropriate validation error will show up.
                return "";
            }
            return "OK";
        }
        /* Check if an audit is required */
        if (auditMessage.requireAudit) {
            if (utilityHelper.isAuditEmpty(audit)) {

                if (utilityHelper.isAuditIncomplete(audit)) {

                    var datePerformedSatisfied = utilityHelper.isAuditDatePerformedSatisfied(audit);

                    if (!datePerformedSatisfied.isValid) {
                        utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, `This AFR requires an audit. ${datePerformedSatisfied.message}`, "", "", errorMessage);
                    }

                    if (!utilityHelper.isAuditorSatisfied(audit)) {
                        utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "This AFR requires an audit. The auditor information is missing", "", "", errorMessage);
                    }

                    if (!utilityHelper.isAuditPDFSatisfied(audit)) {
                        utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, "This AFR requires an audit. Please upload an audit with the AFR submission or indicate that the audit PDF will be sent via email.", "", "", errorMessage);
                    }
                } else {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, `This AFR requires an audit. ${auditMessage.message}`, "", "", errorMessage);
                }

                return "";
            }
            return "OK";
        } else {
            if (audit.auditType === "DEW") {
                // For 2024 and later no additional reporting needs to be done to report a DEW
                if (afr.year < 2024 && utilityHelper.isDEWEmpty(afr)) {
                    var missingAccounts: string[] = utilityHelper.collectMissingDEWEntries(afr);
                    var msg = "you must report a Data Element Worksheet. You have chosen a DEW, but are missing values for the following accounts: "
                    if (missingAccounts.length > 0) {
                        msg += missingAccounts.join(", ");
                    }
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, `An audit is not required but ${msg}`, "", "", errorMessage);
                }
                return "OK";
            } else {
                if (!utilityHelper.isAuditEmpty(audit)) {
                    // We have an audit, and all elements are present
                    return "OK";
                }
                var preamble = "You selected that an audit was performed. ";
                if (afr.year < 2024) {
                    preamble = "An audit is not required but a DEW or audit must be submitted. You selected that an audit was performed. ";
                }
                // We have an audit but are missing some elements
                var datePerformedSatisfied = utilityHelper.isAuditDatePerformedSatisfied(audit);
                if (!datePerformedSatisfied.isValid) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, preamble + `${datePerformedSatisfied.message}`, "", "", errorMessage);
                }

                if (!utilityHelper.isAuditorSatisfied(audit)) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, preamble + "The auditor information is missing", "", "", errorMessage);
                }

                if (!utilityHelper.isAuditPDFSatisfied(audit)) {
                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error, preamble + "Please upload an audit PDF with the AFR submission or select the checkbox to indicate the audit PDF will be sent via email.", "", "", errorMessage);
                }
            }
            return "OK";
        }


    }

    static getSelectedAffiliateReport(mergedAffiliates: Array<AffiliateReporting>, code: string): AffiliateReporting | null {
        if (mergedAffiliates && mergedAffiliates.length > 0) {
            var index = mergedAffiliates.findIndex(x => x.affiliateReference ? x.affiliateReference.code === code : false);
            if (index > -1) {
                return mergedAffiliates[index];
            }
        }
        return null;
    }

    static getFact(mergedFacts: Array<factValue>, tableName: string, rowId: string, fundGroup: string) {
        if (mergedFacts && mergedFacts.length > 0) {

            var fact = mergedFacts.filter(x => (x.tableId === tableName && x.rowId === rowId && x.fundGroup === fundGroup));

            if (fact.length > 0) {
                if (fact[0].value.trim() === "") {
                    return null;
                }
                return fact[0];
            }

        }
        return null;
    }

    static getMergedFacts(tableName: String, afr: Afr, miscFact: Array<factValue>) {
        var facts: Array<factValue> = [];
        var factObject: factValue;

        /*To do: Each table has a spefic logic to be populated, 
         *       I have only implemented the logic to populate the facts for Affiliated entities
         *       the other tables can be added to this helper
         *                                                                             */
        if (tableName === enums.tableName.affiliatedEntity) {
            var afrTable = getTable(afr, enums.tableName.affiliatedEntity);
            if (!afrTable) {
                return miscFact;
            }
            var index = 0;

            for (var row of afrTable.rows) {
                for (var fact of row.facts) {
                    factObject = {
                        tableId: enums.tableName.affiliatedEntity,
                        rowId: this.getFactAffiliateCode(fact),
                        fundGroup: fact.concept.id,
                        concept: fact.concept.id,
                        value: fact.value.toString(),
                    }

                    facts.push(factObject);
                }
            }

            for (var f of miscFact) {
                index = facts.findIndex(x => (x.tableId === f.tableId && x.rowId === f.rowId && x.fundGroup === f.fundGroup));

                if (index > -1) {
                    if (facts[index].value.trim() != "") {
                        facts[index] = f;
                    }

                } else {
                    facts.push(f);
                }
            }

        }

        return facts
    }


    /* check if Affiliated Entity section is satisfied */
    static isAffiliatedEntitySatisfied(afr: Afr | null, errorMessage: Array<AFRError>, dispatch: any) {
        // First verify if exist at least one affiliated entity 
        // with type NOT IN ( independent or non-component )
        var facts: Array<factValue>;
        var miscFacts: Array<factValue>;

        var errorCount: number = 0;

        if (afr && afr.affiliateReporting) {

            const mergedAffiliates: Array<AffiliateReporting> = dispatch(getSelector(getMergedAEs));

            /* it must exist 3 facts per row  */
            facts = dispatch(getSelector(getTableFacts));
            miscFacts = JSON.parse(JSON.stringify(facts));

            // Merge loaded facts with pending changes
            const mergedFacts = utilityHelper.getMergedFacts(enums.tableName.affiliatedEntity, afr, miscFacts);

            var affTable = getTable(afr, enums.tableName.affiliatedEntity);
            if (affTable && mergedFacts) {

                var factRevenues: factValue | null;
                var factExpenditures: factValue | null;
                var factDebt: factValue | null;
                var currentAffiliatedEntity: AffiliateReporting | null | undefined;

                for (var row of affTable.rows) {
                    var affiliatedEntityId = "";
                    var affiliatedEntityName = "";
                    var affiliatedEntityRowId = "";
                    var drUnit: DimensionReference | null = this.getDimensionReferenceForAxis(row.dimensions, enums.axisIds.ReportingUnit);
                    if (drUnit != null) {
                        affiliatedEntityId = drUnit.member ? drUnit.member.code : "";
                        affiliatedEntityName = drUnit.member ? drUnit.member.name : "";
                        affiliatedEntityRowId = drUnit.member ? drUnit.member.id : "";
                    }

                    currentAffiliatedEntity = utilityHelper.getSelectedAffiliateReport(mergedAffiliates, affiliatedEntityId);

                    factRevenues = utilityHelper.getFact(mergedFacts, enums.tableName.affiliatedEntity, affiliatedEntityId, enums.affiateEntityColumn.revenues);
                    factExpenditures = utilityHelper.getFact(mergedFacts, enums.tableName.affiliatedEntity, affiliatedEntityId, enums.affiateEntityColumn.expenditures);
                    factDebt = utilityHelper.getFact(mergedFacts, enums.tableName.affiliatedEntity, affiliatedEntityId, enums.affiateEntityColumn.debt);
                    if (utilityHelper.isAffiliatedEntityNotSpecifiedOrIndependentOrNonComponentUnit(affiliatedEntityId, mergedAffiliates)) {

                        if (factRevenues || factExpenditures || factDebt) {
                            errorCount = errorCount + 1;
                            /* Cannot report Revenues, Expenditures, and Long-term debt for AEs that are Not specified, Independently Reported and Not a Component Unit  */
                            utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                `Affiliate ${affiliatedEntityName} cannot report Revenues, Expenditures, and Long-term debt when the reporting type is Not specified, Independently Reported and Not a Component Unit.`,
                                enums.UISection.affiliatedEntities, affiliatedEntityRowId, errorMessage);
                        }
                    }

                    if (!utilityHelper.isAffiliatedEntityIndependentOrNonComponentUnit(affiliatedEntityId, mergedAffiliates)) {

                        if (utilityHelper.isAffiliatedEntityNotSpecified(affiliatedEntityId, mergedAffiliates)) {
                            errorCount = errorCount + 1;
                            var factRef: ErrorFactReference = {
                                dimensions: [{
                                    axis: "ReportingUnitAxis",
                                    member: affiliatedEntityId,
                                    typedContent: ""
                                }],
                                concept: { id: "AffiliateReportingTypeId" },
                                value: 0,
                                textValue: "RT_NotSpecifiedMember"
                            }
                            utilityHelper.addErrorIfNotFlagged(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                `Affiliate ${affiliatedEntityName} must have a valid Reporting Type.`,
                                enums.UISection.affiliatedEntities, affiliatedEntityRowId, errorMessage, factRef);

                        } else {

                            if (factRevenues === null || factExpenditures === null || factDebt === null) {

                                errorCount = errorCount + 1;
                                /* Cannot report Revenues, Expenditures, and Long-term debt for AEs that are Not specified, Independently Reported and Not a Component Unit  */
                                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                    `Affiliate ${affiliatedEntityName} must have revenues, expenditures, and debt reported. Please provide this information.`,
                                    enums.UISection.affiliatedEntities, affiliatedEntityRowId, errorMessage);

                            }

                        }
                        // Now check for budget variance documents
                        if (afr.year >= 2021 && afr.currentversion && affiliatedEntityId < "500000") {
                            var bMissingVarianceOrNoDoc = true;
                            if (afr.currentversion.documents) {
                                var varianceDoc = afr.currentversion.documents.find(doc => doc.affiliate === affiliatedEntityId && doc.role === enums.documentRole.budget_variance_report);
                                if (varianceDoc) {
                                    bMissingVarianceOrNoDoc = false;
                                }
                            }
                            if (bMissingVarianceOrNoDoc) {
                                errorCount = errorCount + 1;
                                /* Must supply a budget variance document or a declaration of no document  */
                                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                    `Affiliate ${affiliatedEntityName} must upload a Budget Variance document or a declaration that no document is available. Please provide this information.`,
                                    enums.UISection.affiliatedEntities, affiliatedEntityRowId, errorMessage);
                            }
                        }


                        if (utilityHelper.isCRAAuditRequired(mergedAffiliates, mergedFacts, affiliatedEntityId)) {

                            var audit: Audit | null = null;
                            if (currentAffiliatedEntity && currentAffiliatedEntity.audit) { audit = currentAffiliatedEntity.audit }
                            if (!audit) {
                                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                    `Affiliate ${affiliatedEntityName} requires an audit.`,
                                    "", "", errorMessage);
                                errorCount = errorCount + 1;
                                continue;
                            }
                            if (utilityHelper.isAuditIncomplete(audit)) {

                                var datePerformedSatisfied = utilityHelper.isAuditDatePerformedSatisfied(audit);

                                if (!datePerformedSatisfied.isValid) {
                                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                        `Affiliate ${affiliatedEntityName} requires an audit. ${datePerformedSatisfied.message}`,
                                        "", "", errorMessage);
                                }

                                if (!utilityHelper.isAuditorSatisfied(audit)) {
                                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                        `Affiliate ${affiliatedEntityName} requires an audit. The auditor information is missing`,
                                        "", "", errorMessage);
                                }

                                if (!utilityHelper.isAuditPDFSatisfied(audit)) {
                                    utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                        `Affiliate ${affiliatedEntityName} requires an audit. Please upload an audit with the AFR submission or indicate that the audit PDF will be sent via email.`,
                                        "", "", errorMessage);
                                }
                            } else {
                                utilityHelper.addError(afr, enums.errorType.sectionRuleEvaluator, enums.severity.error,
                                    `Affiliate ${affiliatedEntityName} requires an audit.`,
                                    enums.UISection.affiliatedEntities, affiliatedEntityRowId, errorMessage);
                            }

                            errorCount = errorCount + 1;

                        }

                    }

                }
            }

        }

        if (errorCount > 0) { return ""; }
        return "OK";
    }

    static isCRAAuditRequired(mergedAffiliates: Array<AffiliateReporting>, mergedFacts: Array<factValue>, affiliatedEntityCode: string) {

        var isCRA: boolean = false;
        const CRA: string = "Community Redevelopment Agencies";
        var audit: Audit | null = null;

        var currentAffiliatedEntity: AffiliateReporting | null = utilityHelper.getSelectedAffiliateReport(mergedAffiliates, affiliatedEntityCode);

        isCRA = ((currentAffiliatedEntity && currentAffiliatedEntity.affiliateReference && currentAffiliatedEntity.affiliateReference.category === CRA) ? true : false);

        // check if amount revenues are greater than 100.000
        if (!isCRA) {
            return false;
        }


        // get the column information for revenues
        var factRevenues = utilityHelper.getFact(mergedFacts, enums.tableName.affiliatedEntity, affiliatedEntityCode, enums.affiateEntityColumn.revenues);
        var factExpenditures = utilityHelper.getFact(mergedFacts, enums.tableName.affiliatedEntity, affiliatedEntityCode, enums.affiateEntityColumn.expenditures);

        if (factRevenues || factExpenditures) {
            if ((factRevenues && utilityHelper.getNumber(factRevenues.value) > 100000) || (factExpenditures && utilityHelper.getNumber(factExpenditures.value) > 100000)) {

                if (currentAffiliatedEntity && currentAffiliatedEntity.audit) { audit = currentAffiliatedEntity.audit }

                if (utilityHelper.isAuditEmpty(audit)) {
                    return true;
                }

            };
        }

        return false;

    }

    static updateAffiliatedEntityFact(tableName: string, cell: any): factValue | null {
        var row = cell.getRow();
        var rowid = row.getData().dimensionCode;
        var accountid = cell.getField();
        var newvalue = cell.getValue();

        // NOTE: This is a column-concept table - so the concept is taken from the column id (field), and the dimension (equivalent to fundgroup) is now the row id.
        var fact =
        {
            tableId: tableName,
            rowId: rowid,
            fundGroup: accountid,
            concept: accountid,
            value: newvalue,
        };

        if (accountid === 'reporttype') { return null; }

        return fact;

    }

    static abstractAffiliatedEntityRowFact(tableName: string, row: any): factValue | null {
        var rowid = row.getData().dimensionCode;
        var accountid = "unknown";
        var newvalue = "";

        // NOTE: This is a column-concept table - so the concept is taken from the column id (field), and the dimension (equivalent to fundgroup) is now the row id.
        var fact =
        {
            tableId: tableName,
            rowId: rowid,
            fundGroup: accountid,
            concept: accountid,
            value: newvalue,
        };

        return fact;

    }

    static convertText(dataType: string, val: string): string {
        if (!dataType) {
            return val;
        }
        var modVal: string = val;
        switch (dataType) {
            case enums.conceptDatatype.XBRLI_DATEITEMTYPE:
                var parts: string[] = val.split('/');
                if (parts.length === 3) {
                    modVal = parts[2] + '-' + parts[0] + '-' + parts[1];
                }
                break;
        }
        return modVal;
    }
    static generateRowDimId(rowData: any, inUse: any, copyLevel: number): string {
        var rowid = "";
        var copySuffix = " copy(" + copyLevel + ")";
        for (var dimRaw of rowData.dimensionFields) {
            var dim = dimRaw;
            var dimType : string = "";
            var idx = dimRaw.indexOf(':');
            if (idx > 0) {
                dim = dimRaw.substring(0, idx);
                dimType = dimRaw.substring(idx + 1);
            }
            if (rowid.length === 0) {
                rowid = "|";
            } else {
                rowid += "|";
            }
            if (!rowData.hasOwnProperty(dim) || !rowData[dim] || rowData[dim].length === 0) {
                rowid += "?";
            } else {
                // For case insensitive comparison
                rowid += utilityHelper.convertText(dimType, rowData[dim]);
                if (copyLevel > 0 && copySuffix.length > 0) {
                    switch (dimType) {
                        case enums.conceptDatatype.STRING:
                            var idxCopy = rowid.indexOf(" copy(");
                            if (idxCopy <= 0) {
                                rowid += copySuffix;
                            } else {
                                rowid = rowid.substring(0, idxCopy) + copySuffix;
                            }
                            copySuffix = "";
                            break;
                    }
                }
            }
        }
        // Make sure the keys for the inUse map are lower case to provide case insensitive matching
        if (copyLevel < 3 && inUse.hasOwnProperty(rowid.toLowerCase())) {
            rowid = utilityHelper.generateRowDimId(rowData, inUse, copyLevel + 1);
        }
        inUse[rowid.toLowerCase()] = copyLevel;
        return rowid;
    }
    static getDimensionReferenceForAxis(dims: DimensionReference[], axisId: string): DimensionReference | null {
        if (!dims || dims.length === 0) {
            return null;
        }
        var matched = dims.find(d => d.axis.id === axisId);
        if (matched == null) {
            return null;
        }
        return matched;
    }
    static getDimensionalAffiliateId(dims: DimensionReference[]): string {
        var drUnit: DimensionReference | null = utilityHelper.getDimensionReferenceForAxis(dims, enums.axisIds.ReportingUnit);
        if (drUnit) {
            if (drUnit.member != null) {
                return drUnit.member.id;
            }

        }
        return "unknown";

    }
    static getFactAffiliateId(f: Fact): string {
        var drUnit: DimensionReference | null = utilityHelper.getDimensionReferenceForAxis(f.dimensions, enums.axisIds.ReportingUnit);
        if (drUnit) {
            if (drUnit.member != null) {
                return drUnit.member.id;
            }
        }
        return "unknown";
    }
    static getFactAffiliateCode(f: Fact): string {
        var drUnit: DimensionReference | null = utilityHelper.getDimensionReferenceForAxis(f.dimensions, enums.axisIds.ReportingUnit);
        if (drUnit) {
            if (drUnit.member != null) {
                return drUnit.member.code;
            }
        }
        return "unknown";
    }
    static getRowDimensionFacts(tableName: string, rowData: any, inUse: any): Array<factValue> {
        var updatedFacts: Array<factValue> = [];

        if (!rowData.conceptFields) {
            return updatedFacts;
        }

        var rowid = "";
        if (rowData.dimensionFields) {
            rowid += utilityHelper.generateRowDimId(rowData, inUse, 0);
        } else {
            rowid = rowData.dimensionCode;
        }
        var rowConceptId = null;
        if (rowData.hasOwnProperty("rowConceptId")) {
            rowConceptId = rowData["rowConceptId"];
        }
        for (var conceptId of rowData.conceptFields) {
            var factValue = rowData[conceptId];
            if (factValue == null || factValue.length === 0) {
                // don't produce empty facts
                continue;
            }
            // NOTE: This is a column-concept table - so the concept is taken from the column id (field), and the dimension (equivalent to fundgroup) is now the row id.
            var fact =
            {
                tableId: tableName,
                rowId: rowid,
                fundGroup: conceptId,
                concept: rowConceptId ? rowConceptId : conceptId,
                value: factValue,
            };
            updatedFacts.push(fact);
        }
        if (updatedFacts.length === 0 && rowid.length > 0 && rowData.conceptFields.length > 0) {
            var firstConceptId = rowData.conceptFields[1];
            // NOTE: This is a column-concept table - so the concept is taken from the column id (field), and the dimension (equivalent to fundgroup) is now the row id.
            var placeHolderFact =
            {
                tableId: tableName,
                rowId: rowid,
                fundGroup: firstConceptId,
                concept: rowConceptId ? rowConceptId : firstConceptId,
                value: "0"
            };
            updatedFacts.push(placeHolderFact);
        }
        return updatedFacts;

    }
    static getDataFieldIds = function (table: any): string[] {
        var colDefs: any[] = table.getColumnDefinitions();
        var tableRows: any[] = table.getData();
        var fieldIds: string[] = [];
        if (colDefs) {
            colDefs.map(cd => {
                if (cd.hasOwnProperty("columns")) {
                    var cols: any[] = cd.columns;
                    cols.map(col => {
                        if (col.hasOwnProperty("validator")) {
                            fieldIds.push(col.field);
                        }
                    });
                }
            });
        }
        return fieldIds;
    }

    static getRowFacts(tableName: string, fields: string[], rowData: any, inUse: any): Array<factValue> {
        var updatedFacts: Array<factValue> = [];
        var rowid = "";
        for (var fieldId of fields) {
            rowid = rowData.accountCode;
            var conceptId = rowData.accountId;
            var factValue = rowData[fieldId];
            if (!factValue || factValue.length === 0) {
                // don't produce empty facts
                continue;
            }
            var fact =
            {
                tableId: tableName,
                rowId: rowid,
                fundGroup: fieldId,
                concept: conceptId,
                value: factValue,
            };
            updatedFacts.push(fact);
        }

        return updatedFacts;

    }

    static updateSupplementalCompensation(tableName: string, sliceId: string | null, cell: any): factValue {
        var row = cell.getRow();
        var rowData = row.getData();
        var rowid = rowData.accountCode;
        if (rowData.dimensionFields) {
            for (var dim of rowData.dimensionFields) {
                rowid += "|";
                if (!rowData.hasOwnProperty(dim) || !rowData[dim] || rowData[dim].length === 0) {
                    rowid += "?";
                } else {
                    rowid += rowData[dim];
                }
            }
        }
        if (sliceId) {
            rowid = rowid + "|" + sliceId;
        }
        var accountid = row.getData().accountId;// cell.getField();
        var newvalue = cell.getValue();
        // NOTE: This is more common - a row-concept table
        //- so the concept is taken from the row id, and the dimension(equivalent to fundgroup) is now the column(field) id.

        var fact =
        {
            tableId: tableName,
            rowId: rowid,
            fundGroup: cell.getField(),
            concept: accountid,
            value: newvalue,
        };


        return fact;

    }

    static flattenRowList(rows: any[], result: any[]): any[] {
        for (var row of rows) {
            result.push(row);
            if (row.hasOwnProperty("_children")) {
                this.flattenRowList(row._children, result);
            }
        }
        return result;
    }

    static updateTablePendingFacts(tableName: string, fg : string | null, tabulatorTable: any, dispatch: any) {
        var updatedFact: factValue | null;
        var factCells: Array<factValue> = []; /* for the tables that are saved whole  */
        var sliceId : string | null = null;
        var minAccount : string | null = null;
        var maxAccount: string | null = null;
        if (tableName.indexOf("^") > 0) {
            var parts = tableName.split("^");
            tableName = parts[0];
            if (parts.length === 2) {
                sliceId = parts[1];
            } else {
                minAccount = parts[1];
                maxAccount = parts[2];
            }
        }
        switch (tableName) {
            case enums.tableName.millagerates:
            case enums.tableName.specialassessmentrates:
                var table = tabulatorTable;
                var rows : any[] = [];
                rows = table.getData();
                var inUse = {};
                for (var dataRow of rows) {
                    var rowConcept = dataRow.accountid;
                    var updatedFacts = utilityHelper.getRowDimensionFacts(tableName, dataRow, inUse);
                    for (var fact of updatedFacts) {
                        factCells.push(fact);
                    }
                }
                var replaceFacts: bulkFactValues = {
                    tableId: tableName,
                    fundGroup: null,
                    sliceId: sliceId,
                    minAccount: null,
                    maxAccount: null,
                    facts: factCells
                }
                dispatch(setReplaceTableFacts(replaceFacts));
                break;

            case enums.tableName.affiliatecompensation:
            case enums.tableName.compensation:
            case enums.tableName.affiliatedEntity:
                // do nothing for now - this is not supported for this table
                break;

            case enums.tableName.affiliateprojects:
            case enums.tableName.projects:
            case enums.tableName.bonds:

                if (!(tabulatorTable)) {
                    alert("Table reference is missing!");
                    return;
                }

                var rows : any[] = [];
                rows = tabulatorTable.getData();
                var inUse = {};
                for (var dataRow of rows) {
                    var updatedFacts = utilityHelper.getRowDimensionFacts(tableName, dataRow, inUse);
                    for (var fact of updatedFacts) {
                        factCells.push(fact);
                    }
                }

                var replaceFacts: bulkFactValues = {
                    tableId: tableName,
                    fundGroup: null,
                    sliceId: sliceId,
                    minAccount: null,
                    maxAccount: null,
                    facts: factCells
                }
                dispatch(setReplaceTableFacts(replaceFacts));

                break;

            case enums.tableName.revenues:
            case enums.tableName.impactfees:
            case enums.tableName.expenditures:
            case enums.tableName.balanceSheet:
                if (!(tabulatorTable)) {
                    alert("Table reference is missing!");
                    return;
                }
                var dataFieldIds = utilityHelper.getDataFieldIds(tabulatorTable);
                var rows : any[] = [];
                rows = utilityHelper.flattenRowList(tabulatorTable.getData(), []);
                var inUse = {};
                for (var dataRow of rows) {
                    var updatedFacts = utilityHelper.getRowFacts(tableName, dataFieldIds, dataRow, inUse);
                    for (var fact of updatedFacts) {
                        factCells.push(fact);
                    }
                }

                var replaceFacts: bulkFactValues = {
                    tableId: tableName,
                    fundGroup: fg,
                    sliceId: sliceId,
                    minAccount: minAccount,
                    maxAccount: maxAccount,
                    facts: factCells
                }
                dispatch(setReplaceTableFacts(replaceFacts));

                break;
            default:
                break;
        }


    }

    static updateTableCell(tableName: string, fg: string | null, tabulatorCell: any, tabulatorTable: any, dispatch: any) {
        var updatedFact: factValue | null;
        var factCells: Array<factValue> = []; /* for the tables that are saved whole  */
        var sliceId : string | null = null;
        var minAccount: string | null = null;
        var maxAccount: string | null = null;
        if (tableName.indexOf("^") > 0) {
            var parts = tableName.split("^");
            tableName = parts[0];
            if (parts.length === 2) {
                sliceId = parts[1];
            } else {
                minAccount = parts[1];
                maxAccount = parts[2];
            }
        }
        if (tabulatorCell) {
            switch (tableName) {
                case enums.tableName.millagerates:
                case enums.tableName.specialassessmentrates:
                    var table = tabulatorCell.getTable();
                    var rows : any[] = [];
                    rows = table.getData();
                    var inUse = {};
                    for (var dataRow of rows) {
                        var rowConcept = dataRow.accountid;
                        var updatedFacts = utilityHelper.getRowDimensionFacts(tableName, dataRow, inUse);
                        for (var fact of updatedFacts) {
                            factCells.push(fact);
                        }
                    }
                    var replaceFacts: bulkFactValues = {
                        tableId: tableName,
                        fundGroup: null,
                        sliceId: sliceId,
                        minAccount: null,
                        maxAccount: null,
                        facts: factCells
                    }
                    dispatch(setReplaceTableFacts(replaceFacts));
                    break;

                case enums.tableName.affiliatedEntity:

                    if (tabulatorCell) {
                        // populate the fact array
                        updatedFact = utilityHelper.updateAffiliatedEntityFact(tableName, tabulatorCell);

                        // save each updated/added fact in miscSlice in redux
                        if (updatedFact) {
                            dispatch(updateTableCell(updatedFact));
                        }
                    }
                    break;

                case enums.tableName.affiliatecompensation:
                case enums.tableName.compensation:

                    if (tabulatorCell) {
                        // populate the fact array
                        updatedFact = utilityHelper.updateSupplementalCompensation(tableName, sliceId, tabulatorCell);
                        // save each updated/added fact in miscSlice in redux
                        if (updatedFact) {
                            dispatch(updateTableCell(updatedFact));
                        }
                    }
                    break;

                case enums.tableName.affiliateprojects:
                case enums.tableName.projects:
                case enums.tableName.bonds:

                    if (!(tabulatorTable)) {
                        alert("Table reference is missing!");
                        return;
                    }

                    var rows : any[] = [];
                    rows = tabulatorTable.getData();
                    var inUse = {};
                    for (var dataRow of rows) {
                        var updatedFacts = utilityHelper.getRowDimensionFacts(tableName, dataRow, inUse);
                        for (var fact of updatedFacts) {
                            factCells.push(fact);
                        }
                    }

                    var replaceFacts: bulkFactValues = {
                        tableId: tableName,
                        fundGroup: null,
                        sliceId: sliceId,
                        minAccount: null,
                        maxAccount: null,
                        facts: factCells
                    }
                    dispatch(setReplaceTableFacts(replaceFacts));

                    break;

                case enums.tableName.revenues:
                case enums.tableName.impactfees:
                case enums.tableName.expenditures:
                case enums.tableName.balanceSheet:
                    if (!(tabulatorTable)) {
                        alert("Table reference is missing!");
                        return;
                    }
                    var dataFieldIds = utilityHelper.getDataFieldIds(tabulatorTable);
                    var rows : any[] = [];
                    rows = utilityHelper.flattenRowList(tabulatorTable.getData(), []);
                    var inUse = {};
                    for (var dataRow of rows) {
                        var updatedFacts = utilityHelper.getRowFacts(tableName, dataFieldIds, dataRow, inUse);
                        for (var fact of updatedFacts) {
                            factCells.push(fact);
                        }
                    }

                    var replaceFacts: bulkFactValues = {
                        tableId: tableName,
                        fundGroup: fg,
                        sliceId: sliceId,
                        minAccount: minAccount,
                        maxAccount: maxAccount,
                        facts: factCells
                    }
                    dispatch(setReplaceTableFacts(replaceFacts));

                    break;

                default:
                    console.log(tableName + " is not recognized for fact submission");
                    break;
            }


        }
    }


    /* ---------------------------------------------------------------------
     * Save all the pending changes on Misc Slice
     * for example: - All the facts edited into the grids
     *              - All the changes on AffiliateReporting object
       ---------------------------------------------------------------------
     */
    static saveDeferredChanges(dispatch: any) {

        /* getSelector function is a Thunk creator to encapsulate the call of any selector like a function */
        const factsEdited: Array<factValue> = dispatch(getSelector(getTableFacts));
        const affiliates: Array<AffiliateReporting> = dispatch(getSelector(getAffiliates));

        const replacementFacts: bulkFactValues = dispatch(getSelector(getReplaceTableFacts));
        if (affiliates && affiliates.length > 0) {

            /* save each into AFRSlice */
            for (var ar of affiliates) {
                dispatch(updateAffiliateReport(ar));
            }

            /* reset affiliates array */
            dispatch(resetAffiliates({}));
        }

        if (factsEdited && factsEdited.length > 0) {
            for (var fact of factsEdited) {
                dispatch(updateTableFact({
                    tableId: fact.tableId,
                    rowId: fact.rowId,
                    fundGroup: fact.fundGroup,
                    concept: fact.concept,
                    value: fact.value
                }));
            }

            /* reset miscFact array */
            dispatch(resetTableFacts({}));
        }
        if (replacementFacts) {
            dispatch(replaceTableFacts(replacementFacts));
        }
        dispatch(resetReplaceTableFacts({}));
    }

    static showOtherSupplementalInformation(entity: Entity | null) {
        if (entity) {
            if (entity.typecode === enums.entityType.specialDistrict) {
                return true;
            }
        }
        return false;
    }

    static showRatesAndBonds(entity: Entity) {
        if (entity) {
            if (entity.typecode === enums.entityType.specialDistrict) {
                if (entity.districtDependency.toUpperCase() === "DEPENDENT") {
                    return false;
                }
                return true;
            }
        }
        return false;
    }

    static getAffiliatedEntityFromTypeReporting(afr: Afr | null, reportingType: string) {
        var entities: Array<AffiliateReporting> = [];
        if (afr && afr.affiliateReporting) {
            return (afr.affiliateReporting.filter(x => x.reportingType === reportingType));
        }
        return entities;
    }


    static existAffiliatedEntityValid(mergedAffiliates: Array<AffiliateReporting>) {
        var existValidAE = 0;

        if (mergedAffiliates && mergedAffiliates.length > 0) {

            existValidAE = mergedAffiliates.findIndex(x => (x.reportingType !== enums.affiliatedEntityReportingType.independent &&
                x.reportingType !== enums.affiliatedEntityReportingType.nonComponentUnit &&
                x.reportingType !== enums.affiliatedEntityReportingType.notSpecified));

            return (existValidAE > -1);
        }
        return false;
    }

    static isAffiliatedEntityNotSpecified(code: string, mergedAffiliates: Array<AffiliateReporting>) {
        var existAE = 0;

        if (mergedAffiliates && mergedAffiliates.length > 0) {

            existAE = mergedAffiliates.findIndex(x => x.reportingType === enums.affiliatedEntityReportingType.notSpecified && x.affiliateReference && x.affiliateReference.code === code);
            return (existAE > -1);
        }
        return false;
    }

    static isAffiliatedEntityIndependentOrNonComponentUnit(code: string, mergedffiliates: Array<AffiliateReporting>) {
        var existAE = 0;

        if (mergedffiliates && mergedffiliates.length > 0) {

            existAE = mergedffiliates.findIndex(x => (x.reportingType === enums.affiliatedEntityReportingType.independent ||
                x.reportingType === enums.affiliatedEntityReportingType.nonComponentUnit) && x.affiliateReference && x.affiliateReference.code === code);
            return (existAE > -1);
        }
        return false;
    }

    static isAffiliatedEntityNotSpecifiedOrIndependentOrNonComponentUnit(code: string, mergedAffiliates: Array<AffiliateReporting>) {
        var existAE = 0;

        if (mergedAffiliates && mergedAffiliates.length > 0) {

            existAE = mergedAffiliates.findIndex(x => (x.reportingType === enums.affiliatedEntityReportingType.independent ||
                x.reportingType === enums.affiliatedEntityReportingType.nonComponentUnit ||
                x.reportingType === enums.affiliatedEntityReportingType.notSpecified)
                && x.affiliateReference && x.affiliateReference.code === code);
            return (existAE > -1);
        }
        return false;
    }
    static getSectionMapping(afr: Afr | null) {
        var sectionMapping: any = {};
        if (afr && afr.taxonomyType) {
            switch (afr.taxonomyType) {
                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    sectionMapping = enums.UISection_CR29;
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    sectionMapping = enums.UISection_CR939;
                    break;

                case TaxonomyTypeEnum.AFR:
                    if (isFundGroupOriented(afr)) {
                        if (afr.affiliateReporting && afr.affiliateReporting.length > 0) {
                            sectionMapping = enums.UISection_FundGroup;
                        } else {
                            sectionMapping = enums.UISection_FundGroup_NoAffiliates;
                        }
                    } else {
                        sectionMapping = enums.UISection;
                    }
                    break;;
            }
        }
        return sectionMapping;
    }

    static getSectionRequiredMapping(afr: Afr | null) {
        var sectionMapping: any = {};
        if (afr && afr.taxonomyType) {
            switch (afr.taxonomyType) {
                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    sectionMapping = enums.checkMarkRequiredSections_CR29;
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    sectionMapping = enums.checkMarkRequiredSections_CR939;
                    break;

                case TaxonomyTypeEnum.AFR:
                    if (isFundGroupOriented(afr)) {
                        sectionMapping = enums.checkMarkRequiredSections_FundGroup;
                    } else {
                        sectionMapping = enums.checkMarkRequiredSections;
                    }
                    break;;
            }
        }
        return sectionMapping;
    }

    static evaluateAllSectionOK = function (user: logerUser | null, afr: Afr | null, entity: Entity | null, errorList: any[], auditMessage: AuditMessage, dispatch: any) {

        var sectionResult = "";
        var sectionCount = 0;
        var sectionOKCount = 0;
        var sectionCode = "";
        var isCheckRequired = false;
        var errorMessage: Array<AFRError> = [];

        if (!(afr)) {
            return false;
        }

        var sectionMapping: any = utilityHelper.getSectionMapping(afr);
        Object.getOwnPropertyNames(sectionMapping).forEach(
            function (section) {
                isCheckRequired = utilityHelper.isSectionRequired(sectionMapping[section], afr, entity);
                // Browse each property in the object
                sectionCode = sectionMapping[section];
                if (sectionCode.length === 2) {
                    if (isCheckRequired) {
                        sectionResult = utilityHelper.evaluateSectionOK(user, afr, entity, sectionCode, auditMessage, errorMessage, dispatch);
                        if (sectionResult === "OK") { sectionOKCount = sectionOKCount + 1; }
                        sectionCount = sectionCount + 1;
                    }
                    /* The else is pending when the section is not required but the customer entered some data */

                }

            }
        );
        if (sectionCount === sectionOKCount && errorList && errorList.length === 0) {
            return true;
        }
        return false;
    }

    static isSectionRequired = function (section: string, afr: Afr | null, entity: Entity | null) {

        var isCheckRequired: boolean = false;
        if (!afr) {
            return false;
        }
        var year: string = afr.year.toString();
        var sectionMapping: any = utilityHelper.getSectionMapping(afr);
        var sectionRequiredMapping: any = utilityHelper.getSectionRequiredMapping(afr);
        for (var sec of Object.getOwnPropertyNames(sectionMapping)) {
            if (sectionMapping[sec] === section) {
                if (sectionRequiredMapping.hasOwnProperty(sec)) {
                    if (afr.taxonomyType !== TaxonomyTypeEnum.AFR) {
                        return true;
                    }

                    isCheckRequired = true;
                    if (utilityHelper.isSectionExcludedByYear(section, year)) {
                        isCheckRequired = false;
                    }
                    switch (section) {
                        case enums.UISection.otherAfrData:
                            if (entity !== null && entity && entity.typecode.trim() != enums.entityType.county) {
                                isCheckRequired = false;
                            }
                            break;

                        case enums.UISection.affiliatedEntities:
                            if (entity !== null && entity && (entity.typecode.trim() != enums.entityType.county && entity.typecode.trim() != enums.entityType.city)) {
                                isCheckRequired = false;
                            }
                            break;
                    }
                    return isCheckRequired;
                }
            }

        }
        return isCheckRequired;

    }

    static getStatusDescription = function (status: string) {
        return enums.AFRStatusDescription[status.toLowerCase()];
    }

    static isWaiversUploaded = function (afr: Afr) {
        return (getFirstDocumentIndexFromRole(afr, enums.documentRole.impact_fee_waiver, null) > -1);
    }

    static isExceptionsUploaded = function (afr: Afr) {
        return (getFirstDocumentIndexFromRole(afr, enums.documentRole.impact_fee_exception, null) > -1);
    }

    static isAffidavtUploaded = function (afr: Afr) {
        return (getFirstDocumentIndexFromRole(afr, enums.documentRole.affidavit, null) > -1);
    }


    static getFactValue = function (afr: Afr, table: string, rowCode: string) {
        var row: any | null = null;
        var returnValue = "";
        const tableId = getTable(afr, table);
        // get affiliated entity row in redux
        if (tableId) {
            row = getRow(tableId, rowCode);

            if (row && row.facts && row.facts.length > 0) {
                // Assume a 1-column table for now
                returnValue = row.facts[0].value + "";
            }

        }
        return returnValue;
    }

    static getExpendituresTotal = function (afr: Afr) {
        let total = getTableTotals(afr, enums.tableName.expenditures);
        return total;
    }

    static getRevenuesTotal = function (afr: Afr) {
        let total = getTableTotals(afr, enums.tableName.revenues);
        total = total + getTableTotals(afr, enums.tableName.impactfees);
        return total;
    }

    static getImpactFeesTotal = function (afr: Afr) {
        let total = getTableTotals(afr, enums.tableName.impactfees);
        return total;
    }


    static showTab(afr: Afr | null, table: string) {
        var render: boolean = true;
        if (afr) {

            let exclusionByYear = enums.tableExludedByYear.find(x => x.year === afr.year.toString());

            if (typeof exclusionByYear === "undefined") {
                render = true;
            } else {
                // verify if the current section is in the list of exluded tables for this year
                var index = exclusionByYear.tables.findIndex(x => x.code === table);
                render = false;
                if (index === -1) {
                    render = true;
                }
            }

        }

        return render;
    }

    static isSectionExcludedByYear = function (section: string, year: string) {

        if (!enums.sectionExcludedByYear.hasOwnProperty(year)) {
            return false;
        }

        /* getting the sections allowed */
        var sectionDetails: Array<string> = enums.sectionExcludedByYear[year];
        return (sectionDetails.indexOf(section) >= 0);

    }
    static hasAffiliates = function (afr: Afr | null): boolean {
        if (!afr) {
            return false;
        }
        if (afr && afr.affiliateReporting && afr.affiliateReporting.length > 0) {
            return true;
        }
        return false;

    }

    static renderAFRMenuOption = function (afr: Afr | null, entity: Entity | null, section: string) {
        let render: boolean = false;
        if (afr) {
            render = !utilityHelper.isSectionExcludedByYear(section, afr.year.toString());

            if (section === enums.UISection.affiliatedEntities && render) {
                render = false;
                if (entity) {

                    /* Check if there are affiliated entities to show */
                    if (afr.affiliateReporting && afr.affiliateReporting.length > 0) {
                        render = true;
                    }
                }
            } else if (section === enums.UISection.componentUnitsFunds && render) {
                return utilityHelper.hasAffiliates(afr);
            }
        }
        return render;

    }

    static getSeverity = function (severity: number) {
        switch (severity) {
            case 1: return "Error";
            case 2: return "Warning";
            case 3: return "Information";
            default: return ""
        }
    }

    static mergeErrors(newErrors: Array<ErrorSummaryAFRSection>, currentErrors: Array<ErrorSummaryAFRSection>) {
        var mergedErrors: Array<ErrorSummaryAFRSection> = [];
        return { errors: mergedErrors, existChanges: false };
    }

    /******************************************************************************
    Example usage:
        pad(10, 4);      // 0010
        pad(9, 4);       // 0009
        pad(123, 4);     // 0123
        pad(10, 4, '-'); // --10
    ******************************************************************************/
    static pad(n: any, width: any, z = "") {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    static isNullOrEmpty(value: any) {
        if (value === null) {
            return true;
        }

        if (value === "") {
            return true;
        }

        if ((typeof value) === "undefined") {
            return true;
        }
        return false;

    }

    static removeDuplicatesFromArray(array: any) {

        const packedArray: any[] = []
        const dictionary: any = {}

        array.forEach((object: any) => {
            var key = JSON.stringify(object);

            if (dictionary[key]) return
            dictionary[key] = true
            packedArray.push(object)
        });

        return packedArray;
    }
    static removeNonTokenCharacters(s: string): string {
        return s.replace(/[^a-zA-Z0-9\-_]/g, '');
    }
    static removeNonCodeCharacters(s: string): string {
        return s.replace(/[^a-zA-Z0-9\.]/g, '');
    }
    static removeNonAccountCodeCharacters(s: string): string {
        return s.replace(/[^0-9\.]/g, '');
    }

    /* For now is it formatting numbers but any data type can be added in the future */
    static FormatterWithDecimals(value: string, format: string, numDecimals: number) {
        if (!value) {
            return value;
        }
        /* the format parameter will be got from taxonomy ( see enums.conceptDatatype) */
        var formattedValue: string = value;

        var key: string = enums.conceptDatatype[format.toUpperCase()];
        if ((typeof value) === "undefined") {
            return value;
        }

        // Include here all the different formats we want to use
        switch (key) {
            case enums.conceptDatatype.NONE:
                break;
            case enums.conceptDatatype.XBRLI_MONETARYITEMTYPE:
                if (value === "999999999999") {
                    // False value used to flag missing facts
                    formattedValue = "NA";
                } else {
                    let options: Intl.NumberFormatOptions = {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: numDecimals,
                        maximumFractionDigits: numDecimals,
                    };

                    var numberFormat = new Intl.NumberFormat('en-US', options);
                    formattedValue = numberFormat.format(Number(value));
                }
                break;

            case enums.conceptDatatype.XBRLI_NONNEGATIVEINTEGERITEMTYPE:
                if (value === "999999999999") {
                    // False value used to flag missing facts
                    formattedValue = "NA";
                } else {
                    formattedValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(value));
                }
                break;
            case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                let option: Intl.NumberFormatOptions = {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 4,
                };
                var formatter = new Intl.NumberFormat("en-US", option);
                let cellValueNumber = Number(value);
                if (cellValueNumber != 0) {
                    formattedValue = formatter.format(Number(value));
                } else {
                    formattedValue = formatter.format(Number(value));
                }

                break;

            case enums.conceptDatatype.XBRLI_DATEITEMTYPE:
                var dateValueMs = Date.parse(value);
                if (isNaN(dateValueMs)) {
                    formattedValue = "invalid date: " + value;
                } else {
                    var dateFormatter = new Intl.DateTimeFormat("en-us");
                    formattedValue = dateFormatter.format(new Date(dateValueMs));
                }
                break;
            default:
        }

        return formattedValue;
    }

    static Formatter(value: string, format: string, places: number = 2) {
        return this.FormatterWithDecimals(value, format, places);
    }
    static createNewRowForTypeDimensionTable = function (currentAfr: Afr, tableName: string, rowDimMap: any, account: Concept | null) {

        var rowdimFields: string[] = [];
        var conceptFields: string[] = [];

        var acctTable = getTable(currentAfr, tableName);
        if (!acctTable) {
            return;
        }
        var accountCode = "";
        var rowConceptId : string | null = null;
        var accountId: string | null = null;
        if (account) {
            accountCode = account.code;
            accountId = account.id;
            rowConceptId = account.id;
        }
        var nextRow: any = {
            id: tableName + "|",
            account: account,
            accountId: accountId,
            accountCode: accountCode,
            dimensionFields: rowdimFields,
            conceptFields: conceptFields
        }
        if (rowConceptId) {
            nextRow["rowConceptId"] = rowConceptId;
        }
        // load axis columns
        var key = "";
        for (var axis of acctTable.structure.rowHierarchy.axes) {
            if (rowDimMap.hasOwnProperty(axis.id)) {
                rowdimFields.push(axis.id);
                nextRow[axis.id] = null;
                key = key + "|";
            }
        }
        nextRow.dimensionFields = rowdimFields;
        nextRow["key"] = key;

        // load column concept
        if (account) {
            nextRow["account"] = account.name;
        }
        if (account) {
            // This is a row concept table these columns are the dimension values that create instances of a fact whose concept is the row concept. Additional dimensions can come from the row
            for (var tbeGroup of acctTable.structure.nthlevelcolumnHierarchy) {
                if (tbeGroup.sublevels) {
                    for (var tbeCol of tbeGroup.sublevels) {
                        if (tbeCol.dimensionaspect.member != null) {
                            conceptFields.push(tbeCol.dimensionaspect.member.id);
                            nextRow[tbeCol.dimensionaspect.member.id] = null;
                        }
                    }
                }
            }
        } else {
            // This is a column concept table (account == null), these columns contain the concept id for a fact, whose dimensions will be coming from the row
            for (var tbeGroup of acctTable.structure.nthlevelcolumnHierarchy) {
                if (tbeGroup.sublevels) {
                    for (var tbeCol of tbeGroup.sublevels) {
                        conceptFields.push(tbeCol.conceptaspect.id);
                        if (tbeCol.conceptaspect.datatype && tbeCol.conceptaspect.datatype === "XBRLI_MONETARYITEMTYPE") {
                            // Only put a default if the datatype is monetary
                            nextRow[tbeCol.conceptaspect.id] = "0";
                        } else {
                            // Put the concept column in the row, but assigned to null
                            nextRow[tbeCol.conceptaspect.id] = null;
                        }
                    }

                }
            }
        }
        nextRow.conceptFields = conceptFields;

        var rateDataType : any[] = [];
        for (var opc of acctTable.structure.rows) {

            if (opc.id.toUpperCase().indexOf("TITLE") > 0) {
                continue;
            }
            rateDataType.push({ id: opc.id, dataType: opc.datatype });
        }
        nextRow["dataType"] = rateDataType;

        return nextRow;
    }

    static convertFromISODate = function (val: string): string {
        var modVal = val;
        var parts: string[] = val.split("-");
        if (parts.length === 3) {
            modVal = parts[1] + '/' + parts[2] + '/' + parts[0];
        }
        return modVal;
    }
    static convertToISODate = function (val: string): string {
        var modVal = val;
        var parts: string[] = val.split("/");
        if (parts.length === 3) {
            modVal = parts[2] + '-' + parts[0] + '-' + parts[1];
        }
        return modVal;
    }
    // Helper to get a cell value
    static getEffectiveStringValue = function (val: string, rowData: any, field: string): string {
        if (val === null || val === undefined || val.length === 0) {
            return "";
        }
        var effectiveVal = val;
        var dataType = enums.conceptDatatype.NONE;
        if (rowData && rowData.dimensionFields) {
            for (var f of rowData.dimensionFields) {
                var parts: string[] = f.split(':');
                if (parts[0] === field) {
                    if (parts.length > 1) {
                        dataType = parts[1];
                    }
                }
            }
        }
        switch (dataType) {
            case enums.conceptDatatype.XBRLI_DATEITEMTYPE:
                // We need to convert to ISO date from US date
                effectiveVal = utilityHelper.convertToISODate(val);
                break;

            case enums.conceptDatatype.DTR_TYPES_PERCENTITEMTYPE:
                effectiveVal = val;  // should support % style better
                break;

            case enums.conceptDatatype.NONE:
                var result = parseInt(val);
                if (!isNaN(result)) {
                    effectiveVal = result + "";
                }
                break;
        }
        return effectiveVal;

    }

    static getEffectiveNumericValue = (e: string): number => {
        if (!e) {
            return 0;
        }
        var result = parseInt(e);
        if (isNaN(result)) return 0;
        return result;

    }

    static getRowDimensionsKey(row: any, changeField: string, changeValue: string) {
        if (!row.hasOwnProperty("dimensionFields")) {
            return "";
        }
        var key = "";
        for (var rawField of row.dimensionFields) {
            var parts: string[] = rawField.split(':');
            var field = parts[0];
            var val = row[field] ? row[field] : "";
            if (field === changeField) {
                val = changeValue;
            }
            key = key + val + "|";
        }
        return key;
    }

    static generateGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static checkForRowDuplicates(table: any, validationRowGuid: string, keyIn: string): boolean {
        var key = keyIn.toLowerCase();
        var rows = table.getData();
        var rowMap: any = {};
        for (var z of rows) {
            var checkRowGuid = z.key;
            if (validationRowGuid !== checkRowGuid) {
                var rowKey = utilityHelper.getRowDimensionsKey(z, "na", "").toLowerCase();
                rowMap[rowKey] = checkRowGuid;
            }
        }
        return rowMap.hasOwnProperty(key);

    }
    static generateNewRowDimensionMap(table: FactTable): any {
        var rowDimMap: any = {};
        if (!table) {
            return rowDimMap;
        }
        var t: Table = table.structure;
        for (var axis of t.rowHierarchy.axes) {
            var drNew: DimensionReference = { axis: axis, member: null, typedContent: null };
            if (axis.typedDomain) {
                drNew.member = axis.typedDomain;
                drNew.typedContent = "";
            } else {
                if (axis.membersByYear && axis.membersByYear.length > 0) {
                    drNew.member = axis.membersByYear[0];
                }
            }

            rowDimMap[axis.id] = drNew;
        }
        return rowDimMap;
    }

    static isNullDocumentRelationship(rel: DocumentRelationship): boolean {
        if (!rel.documentId) {
            return true;
        }
        if (rel.documentId === "00000000-0000-0000-0000-000000000000") {
            return true;
        }
        return false;
    }

    static isNoSendDocumentRelationship(rel: DocumentRelationship): boolean {
        if (rel && rel.name && rel.name.indexOf("send ") === 0) {
            return true;
        }
        return false;
    }

    static isTextPresent = function (textValue: string | undefined | null): boolean | undefined {
        var isValid : boolean | undefined = undefined;
        if (!textValue) {
            return false;
        }

        if (textValue !== undefined) {
            if (textValue.trim().length > 0) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        else {
            isValid = false;
        }

        return isValid;
    }

    static buildSelectionTree = function (cnParent: ConceptNode | null, cnode: ConceptNode, selectedLeafs: string[]) {
        // All nodes are selectable
        var disable = false;
        var itemValue = cnode.concept.code;
        if (cnParent && (itemValue.length < 3)) {
            // This is an object code, so prepend with the account code
            itemValue = cnParent.concept.code + "." + cnode.concept.code;
        }
        var bChecked = selectedLeafs.length === 0 ? false : (selectedLeafs.indexOf(itemValue) >= 0);
        var listItem: SelectableListItem = {
            label: cnode.concept.name,
            value: itemValue,
            disabled: disable,
            checked: bChecked,
            children: []
        }
        if (cnode.children) {
            for (var cnChild of cnode.children) {
                var childItem: SelectableListItem = utilityHelper.buildSelectionTree(cnode, cnChild, selectedLeafs);
                listItem.children.push(childItem);
            }
        }
        return listItem;
    }

    static getListFromTree = function (selectedAccount: string, nodeTree: ConceptNode[] | null) {
        var alist: Array<SelectableListItem> = [];
        if (!nodeTree) {
            return alist;
        }
        if (nodeTree.length > 0) {
            for (var root of nodeTree) {
                alist.push(utilityHelper.buildSelectionTree(null, root, [selectedAccount]));
            }
        }
        return alist;
    }

    static emptyDeprecation: any = { conceptId: "", deprecationDate: "", reason: "", replacements: [], replacementType: "", new: false, dirty: false };

    static getFirstDimensionNotMatching = function (f: Fact, memberId: string | null): DimensionReference | null {
        if (memberId === null) {
            if (f.dimensions.length > 0) {
                return f.dimensions[0];
            }
            return null;
        }
        var matched: DimensionReference | undefined = f.dimensions.find(d => d.member != null && d.member.id !== memberId);
        if (matched == null) {
            return null;
        }
        return matched;
    }
    static getFirstDimensionNotMatchingCode = function (f: Fact, memberCode: string | null): DimensionReference | null {
        if (memberCode === null) {
            if (f.dimensions.length > 0) {
                return f.dimensions[0];
            }
            return null;
        }
        var matched: DimensionReference | undefined = f.dimensions.find(d => d.member != null && d.member.code !== memberCode);
        if (matched == null) {
            return null;
        }
        return matched;
    }
    static insertSpacesInCamelCase = function (source: string): string {
        if (source.indexOf(' ') > 0) {
            // we already have spaces so just return the text
            return source;
        }
        // insert a space before all caps
        return source.replace(/([A-Z])/g, ' $1')
    }
    static getDimensionSignature = function (dimrefs: string[], dr: DimensionReference) {
        if (dr.axis.name === "CompensationCategoryAxis" && dr.member && dr.member.id.indexOf("PP_") >= 0) {
            // This rolls up to the parent entry
            dimrefs.push(dr.axis.name + "#EmployeeMember");
            return;
        }
        if (dr.typedContent) {
            dimrefs.push(dr.axis.name + '#' + dr.typedContent);
        } else {
            dimrefs.push(dr.axis.name + '#' + (dr.member != null ? dr.member.id : ""));
        }
    }
    static getRowSignature = function (accountid: string, dimensions: DimensionReference[] | null): string {
        var dimrefs: string[] = [];
        if (dimensions === null || !dimensions || dimensions.length == 0) {
            return accountid;
        }
        dimensions.map(dr => utilityHelper.getDimensionSignature(dimrefs, dr));
        var result = accountid + "|" + dimrefs.sort().join("|");
        return result;
    }

    // ************************************************************* /*
    // General purpose functions support use of tabulator components //
    // ************************************************************* /*

    // Search a row component given a Account Code
    static getRowFromAccountCode = function (table: any, account: string) {
        if (account.length === 0) { return null }

        if (!table) {
            return null;
        }
        var rows: any[];
        var row: any;

        //get row from the account code
        if (account.includes("|")) { /*sub account*/
            // get the parent row
            var parentAccount = account.split("|")[0].toString();
            rows = table.searchRows("accountCode", "=", parentAccount);

            if (!(rows && rows.length === 1)) {
                return null;
            }
            var rowChildren: any[] = rows[0].getTreeChildren();

            for (row in rowChildren) {
                if (rowChildren[row].getData().accountCode === account) {
                    return rowChildren[row];
                }
            }

        } else {
            rows = table.searchRows("accountCode", "=", account);
            if (rows && rows.length > 0) {
                return rows[0];
            }
        }

        return null;

    }

    // get next row to right to be edited
    static getNextCell = function (cell: any) {
        if (!cell) { return "" };
        var cells: any[] = cell.getRow().getCells();
        var found = false;
        for (var c of cells) {
            if (found) { return c.getField() }
            if (c.getField() === cell.getField()) { found = true; }
        }
        return "";
    }


    // Helper to get a cell value
    static getValue = (e: any) => {
        var result = parseInt(e);
        if (isNaN(result)) return 0;
        return result;

    }

    static getFloatValue = (e: any) => {
        var result = parseFloat(e);
        if (isNaN(result)) return 0.0;
        return result;

    }
    // calculate totals for each row
    static getTotals = function (value: any, rowData: any) {
        let total = 0;

        if (rowData._children) { return "" }

        Object.getOwnPropertyNames(rowData).forEach(
            function (val, idx, array) {
                // Fetch the value associated with the property and try to convert to a number
                // NOTE - some of the row attributes are metadata, not fact values, so they need to be skipped
                switch (val) {
                    case "ratetype":
                    case "account":
                    case "accountId":
                    case "accountCode":
                        break;
                    default:
                        if (utilityHelper.getValue(rowData[val]) != 0) {
                            total = total + utilityHelper.getValue(rowData[val]);
                        }
                        break;
                }
            }
        );

        return total;
    }

    // get the underlying data from a tabulator reference
    static gridData = function (table: any) {
        if (table) {
            var data: any[] = table.getData();
            return data;
        }
        return null;
    }

    static scrollToTableRowByDataKey = function (table: any, dataKey: string, fieldToEdit: string) {
        if (table) {
            var data: any[] = table.getData();
            if (!data || (typeof data[0]) === "undefined") {
                // Nothing to do
                return;
            }

            var rowToSelect: string = dataKey;
            var row: any;

            if (rowToSelect.length === 0) {
                if (data && !((typeof data[0]) === "undefined")) {
                    rowToSelect = data[0].accountCode;
                }
            }

            if (rowToSelect.length === 0) { return }
            //scroll to the row that is being updated
            row = utilityHelper.getRowFromAccountCode(table, rowToSelect)
            if (row == null) {
                return;
            }
            table.scrollToRow(row, "center", true)
                .then(function () {
                    //run code after row has been scrolled to
                    var rdata = row.getData();
                    //                   table.selectRow(row);
                    if (fieldToEdit.length > 0) {
                        var cellToEdit = row.getCell(fieldToEdit);
                        if (cellToEdit) {
                            cellToEdit.edit();
                        }
                    }
                })
                .catch(function (error: any) {
                    //handle error scrolling to row
                    //This hack allows to render all the row out of the viewport 
                    //in this case I am forcing the grid to pull the last row of data
                    console.log("there was an error", dataKey, error);
                    if (data && !((typeof data[0]) === "undefined")) {

                        rowToSelect = data[data.length - 1].accountCode;
                        row = utilityHelper.getRowFromAccountCode(table, rowToSelect);
                        table.scrollToRow(row, "center", true);

                    }

                });
        }


    }

    static taxonomyTitleFromEnumeration = function (enumValue: TaxonomyTypeEnum | null) {
        var result: string = "none";
        if (enumValue) {
            switch (enumValue) {
                case "AFR":
                    result = enumValue;
                    break;
                default:
                    result = utilityHelper.toTitleCase(enumValue);
                    break;
            }
        }
        return result;
    }
    static indexOfDigit = function (src: string): number {
        var iDigit: number = src.length;
        for (var s of ["1", "2", "3", "4", "5", "6", "7", "8", "9"]) {
            var nextDigit = src.indexOf(s);
            if (nextDigit >= 0) {
                if (nextDigit < iDigit) {
                    iDigit = nextDigit;
                }
            }
        }
        if (iDigit < src.length) {
            return iDigit;
        }
        return -1;
    }
    static taxonomyTitleFromConnector = function (connector: string) {
        var tt = connector;
        if (connector.indexOf(",") > 0) {
            tt = connector.split(",")[2];
        }
        var idx: number = utilityHelper.indexOfDigit(tt);
        if (idx >= 0) {
            return utilityHelper.camelCaseToTitleCase(tt.substring(0, idx)) + " " + tt.substring(idx);
        } else {
            return utilityHelper.camelCaseToTitleCase(tt);
        }

    }

    static getTaxonomyDescriptor = (desc: string | null) => {
        if (!desc || desc === "AFR") {
            return "AFR"
        }
        var result = utilityHelper.toTitleCase(desc);
        switch (desc) {
            case "COURT_REPORTING_939":
                result += ".185, F.S.";
                break;

            case "COURT_REPORTING_29":
                result += ".0085, F.S."
                break;

        }
        return result;
    }

    static getAfrYearDescriptor = function (currentAfr: Afr | null): string {
        var result: string = "";

        if (currentAfr) {
            result += currentAfr.year;
            if (currentAfr.logicalPeriod) {
                switch (currentAfr.logicalPeriod) {
                    case "ANNUAL":
                        break;

                    default:
                        result += ", " + currentAfr.logicalPeriod.replace("Q_", "Quarter ");
                        break;

                }
            }
        }
        return result;
    }
    static isAfr = function (currentAfr: Afr | null): boolean {
        var result: boolean = false;
        if (currentAfr && currentAfr.taxonomyType && currentAfr.taxonomyType === "AFR") {
            result = true;
        }
        return result;

    }

    static isNotAnnual = function (currentAfr: Afr | null): boolean {
        var result: boolean = false;
        if (currentAfr && currentAfr.taxonomyType && currentAfr.taxonomyType === "COURT_REPORTING_939") {
            result = true;
        }
        return result;

    }

    static getTaxonomyTypeFromVersion = function (versionInfo: ActiveTaxonomyVersionInfo | null): TaxonomyTypeEnum {
        if (!versionInfo || !versionInfo.type) {
            return TaxonomyTypeEnum.AFR;
        }
        return versionInfo.type;
    }

    static getRevenuesMinusExpenditures = function (facts: Fact[], creditDebitMap: any): number {
        var total: number = 0;
        facts.map(x => {
            if (x.concept && x.concept.id) {
                var cid: string = x.concept.id;
                if (creditDebitMap.hasOwnProperty(cid)) {
                    if (creditDebitMap[cid] === true) {
                        total += x.value;
                    } else {
                        total -= x.value;
                    }
                }
            }
        })
        return total;
    }
    static factMatchesFilter = function (f: Fact, conceptFilter: any, dimensionFilter: any | null): boolean {
        if (conceptFilter && f.concept && !conceptFilter.hasOwnProperty(f.concept.id)) {
            return false;
        }
        if (!dimensionFilter) {
            return true;
        }
        if (!f.dimensions || f.dimensions.length === 0) {
            return false;
        }
        var matched = f.dimensions.filter(d => d.member ? dimensionFilter.hasOwnProperty(d.member.id) : false);
        return matched.length > 0;
    }

    static rowMatchesFilter = function (row: FactTableRow, dimensionFilter: any | null): boolean {
        if (!dimensionFilter) {
            return true;
        }
        if (!row.dimensions || row.dimensions.length === 0) {
            return false;
        }
        var matched = row.dimensions.filter(d => d.member ? dimensionFilter.hasOwnProperty(d.member.id) : false);
        return matched.length > 0;
    }

    static getFilteredTableFacts = function (tb: FactTable | null, conceptFilter: any | null, dimensionFilter: any | null): Fact[] {
        var facts: Fact[] = [];
        if (tb) {
            tb.rows.map(r => {
                r.facts.map(f => {
                    if (utilityHelper.factMatchesFilter(f, conceptFilter, dimensionFilter)) {
                        facts.push(f);
                    }
                })
            });
        }
        return facts;
    }
    static getFilteredTableTotal = function (tb: FactTable | null, conceptFilter: any | null, dimensionFilter: any | null): number {
        var facts: Fact[] = utilityHelper.getFilteredTableFacts(tb, conceptFilter, dimensionFilter);
        var total: number = 0;
        facts.map(f => total += f.value);
        return total;
    }
    static getTableRevenuesMinusExpenditures = function (tbRevenues: FactTable | null, tbExpenditures: FactTable | null, dimensions: string[]): number {
        var dimensionFilter: any | null = null;
        if (dimensions.length > 0) {
            dimensionFilter = {};
            dimensions.map(d => dimensionFilter[d] = true);
        }
        var revTotal: number = tbRevenues ? utilityHelper.getFilteredTableTotal(tbRevenues, null, dimensionFilter) : 0;
        var expTotal: number = tbExpenditures ? utilityHelper.getFilteredTableTotal(tbExpenditures, null, dimensionFilter) : 0;
        return revTotal - expTotal;
    }

    static getFactValueMap = function (tb: FactTable | null): any {
        var result: any = {};
        if (tb) {
            tb.rows.map(fr => {
                fr.facts.map(f => {
                    var factSig = utilityHelper.getRowSignature(f.concept.id, f.dimensions);
                    result[factSig] = f.value;
                })
            });
        }
        return result;
    }

    static getSectionForDimension = function (f: Fact, dmap: any): string {
        var result: string = "none";
        if (f && dmap && f.dimensions && f.dimensions.length > 0) {
            var dim = f.dimensions[0];
            if (dim.member && dim.member.id && dmap.hasOwnProperty(dim.member.id)) {
                result = dmap[dim.member.id];
            }
        }
        return result;
    }
    static getTableNameForFact = function (av: AfrVersion, f: Fact): string {
        var result: string = "none";
        if (av.tables && f && f.concept) {
            var cid = f.concept.id;
            av.tables.map(t => {
                t.structure.rows.map(c => {
                    if (c.id === cid) {
                        result = t.structure.name;
                    }
                })
            });
        }
        return result;
    }

    static uploadSuccessfulNotFinished =
        {
            title: "<h3 style=\"color:green;\">Upload Successful</h3>",
            icon: 'success' as "info" | "success" | "error" | "warning" | "question" | undefined,
            html: "<p style=\"color:green; text-align:center\"> Your document was successfully uploaded! </p> <b><hr style=\" border: 1px solid #000\" /></b> <p style=\"color:red\">Your Annual Financial Report is still <b>In Progress</b>.</p> <p>Please continue entering any outstanding information.</p>"
        };

    static importFailedNotFinished = function (msg: string): any {
        var result : any =
        {
            title: "<h3 style=\"color:black;\">Upload Incomplete</h3>",
            icon: 'error' as "info" | "success" | "error" | "warning" | "question" | undefined,
            html: "<p style=\"color:black; text-align:center\"> Your spreadsheet was partially imported. </p> <b><hr style=\" border: 1px solid #000\" /></b> <p style=\"color:red\">The following financial items were NOT uploaded:</p><p style=\" text-align:left\" >" + msg + "</p>",
            width: "50%"
        };
        return result;
    };

    static getCustomeSuccessfulNotFinished = function (afr: Afr | null) {

        let reportTypeName:string = utilityHelper.getReportTypeName(afr);
        return {
            title: "<h3 style=\"color:green;\">Upload Successful</h3>",
            icon: 'success' as "info" | "success" | "error" | "warning" | "question" | undefined,
            html: "<p style=\"color:green; text-align:center\"> Your document was successfully uploaded! </p> <b><hr style=\" border: 1px solid #000\" /></b> <p style=\"color:red\">Your " + `<span>${reportTypeName}</span>` + " is still <b>In Progress</b>.</p> <p>Please continue entering any outstanding information.</p>"
        };
    }

    static getReportTypeName = function(afr: Afr | null) {
        let reportTypeName: string = "Annual Financial Report";
        if (afr && afr.taxonomyType) {
            switch (afr.taxonomyType) {
                case TaxonomyTypeEnum.AFR:
                    reportTypeName = "Annual Financial Report";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING:
                    reportTypeName = "Court Report";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    reportTypeName = "Court Report 29.0085";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    reportTypeName = "Court Report 939.185";
                    break;

                default:
                    reportTypeName = "Annual Financial Report";
                    break;
            }
        }
        return reportTypeName;
    }
    static getSuccessfulUploadJSON = function generatePopupJSON(afr: Afr | null): {} {

        let reportTypeName: string = "Annual Financial Report";
        if (afr && afr.taxonomyType) {
            switch (afr.taxonomyType) {
                case TaxonomyTypeEnum.AFR:
                    reportTypeName = "Annual Financial Report";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING:
                    reportTypeName = "Court Report";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    reportTypeName = "29 Court Report";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    reportTypeName = "939 Court Report";
                    break;

                default:
                    reportTypeName = "Annual Financial Report";
                    break;
            }
        }

        var result = {
            title: "<h3 style=\"color:green;\">Upload Successful</h3>",
            icon: 'success' as "info" | "success" | "error" | "warning" | "question" | undefined,
            html: `<p style=\"color:green; text-align:center\"> Your document was successfully uploaded! </p> <b><hr style=\" border: 1px solid #000\" /></b> <p style=\"color:red\">Your ${reportTypeName} is still <b>In Progress</b>.</p> <p>Please continue entering any outstanding information.</p>`
        };

        return result;
    }

    static generateNavGroups(tt: TaxonomyTypeEnum | null, navOptions: NavOption[], loggedUser: logerUser, currentAfr: Afr | null,
        selectedEntity: Entity | null, auditMessage: AuditMessage, dispatch: any, errorList: any, rowErrorList : ErrorGrid[]): NavOptionGroup[] {
        var info: NavOptionGroup = {
            options: [],
            group: NavOptionTypeEnum.INFO
        };
        var work: NavOptionGroup = {
            options: [],
            group: NavOptionTypeEnum.WORK
        };
        var submit: NavOptionGroup = {
            options: [],
            group: NavOptionTypeEnum.SUBMIT
        };
        var complete: NavOptionGroup = {
            options: [],
            group: NavOptionTypeEnum.COMPLETE
        };
        var errorMessage: Array<AFRError> = [];
        navOptions.map((opt, idx) => {
            var optState: NavOptionState = {
                option: opt
            };
            switch (opt.optionType) {
                case NavOptionTypeEnum.INFO:
                    info.options.push(optState);
                    break;
                case NavOptionTypeEnum.SUBMIT:
                    submit.options.push(optState);
                    break;
                case NavOptionTypeEnum.COMPLETE:
                case NavOptionTypeEnum.WORK:
                    var sectionHasErrors : boolean = false;
                    let errorSection = errorList.find((x: any) => x.section.sectionCode === opt.section);
                    if (errorSection === undefined) {
                        if (rowErrorList && rowErrorList.length > 0 ) {
                            var sectionToMatch = "none";
                            if (currentAfr && currentAfr.afrId > "3") {
                                sectionToMatch = enums.UISection.otherAfrData;
                            } else {
                                sectionToMatch = enums.UISection.affiliatedEntities;
                            }
                            if (opt.section === sectionToMatch) {
                                sectionHasErrors = true;
                            }
                        }
                    } else {
                        sectionHasErrors = true;
                    }
                    // auditMessage: AuditMessage, errorMessage: Array<AFRError>, dispatch: any
                    if (utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)) {
                        if (!sectionHasErrors) {
                            complete.options.push(optState);
                        } else {
                            work.options.push(optState);
                        }
                    } else {
                        if (!sectionHasErrors) {
                            var evalMsg: string = currentAfr ?
                                utilityHelper.evaluateSectionOK(loggedUser, currentAfr, selectedEntity, opt.section, auditMessage, errorMessage, dispatch).toLowerCase()
                                : "";

                            let factsValueFound: string | null | undefined;
                            if (currentAfr != null) {
                                if (currentAfr.taxonomyType === "COURT_REPORTING_29") {
                                    if (currentAfr.currentversion) {
                                        factsValueFound = utilityHelper.getCR29FactsAndDocuments(currentAfr);
                                        if (factsValueFound === "NoCPALetter") {
                                            work.options.push(optState);
                                        } else if (factsValueFound === "HasFacts") {
                                            complete.options.push(optState);
                                        } else {
                                            work.options.push(optState);
                                        }
                                    }
                                }
                                else {
                                    if (evalMsg === "ok") {
                                        complete.options.push(optState);
                                    } else {
                                        work.options.push(optState);
                                    }
                                }
                            }
                        } else {
                            work.options.push(optState);
                        }
                    }
                    break;
            }
        })
        var result: NavOptionGroup[] = [info, work, submit, complete];
        if (tt) {
            switch (tt) {
                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    result = [info, work, complete];
                    break;

                default:
                    result = [info, work, submit, complete];
                    break;
            }
        }
        return result;
    }

    static getDataSection = function (fundGroup: string | null, tableName: string) {
        if (fundGroup) {
            return fundGroup + " Funds";
        }
       var result = tableName;
        if (enums.dataSectionAlias.hasOwnProperty(tableName)) {
            result = enums.dataSectionAlias[tableName];
        }
        return result;
    }

    static IsAuthorizedGivenContactRoleUserRoleReportAccess = function (userType: string | null, entitySelector: Entity | null, authorizedEntitiesSelector: EntityAuthorization[] | null, entityContactRole: EntityContactRole, entityUserRole: EntityUserRole, reportAccess: ReportAccessEnum | null, ): boolean {

        let result: boolean = false;

        if (userType && userType == UserRoleEnum.Admin) {
            result = true;
        }
        else {
            if (entitySelector && authorizedEntitiesSelector) {
                result = authorizedEntitiesSelector.some((element: EntityAuthorization) => element.entity.code == entitySelector.code
                    && element.entityContactRole == entityContactRole.toString()
                    && element.entityUserRole == entityUserRole.toString()
                    && (reportAccess == null || (reportAccess && reportAccess.toString() == element.reportAccess)));  
            }
        }
        return result;
    }

    static getRoleUserName = function (creator: any): string {
        return creator.role == UserRoleEnum.Admin ? 'DFS_' + creator.lastName : creator.lastName
    }
    static getEntityName = function (e: Entity | null, afr: Afr | null): string {
        if (!e) {
            return "";
        }
        if (!afr) {
            return e.name;
        }
        return getNameForAfr(e, afr);
    }
    static getEntityCode = function (e: Entity | null, afr: Afr | null): string {
        if (!e) {
            return "";
        }
        if (!afr || !afr.owner) {
            return e.code;
        }

        return afr.owner.code;
    }
    static getFundGroupTitle = function (fg: string): string {
        var result = fg;
        if (fg.indexOf("Funds") < 0) {
            result += " Funds";
        }
        if (fg === "Component Units") {
            return "Discrete " + result;
        }
        return result;
    }

    static stripCodePrefix = function (name: string) {
        var parts: string[] = name.split(" - ");
        if (parts.length > 1) {
            return parts[1];
        } else {
            return parts[0];
        }
    }
    static addFundGroups = function (currentAfr : Afr | null, rowMatch: MatchTableFacts): string[] {
        var fundList: string[] = [];
        if (currentAfr) {
            getMatchingFacts(currentAfr, rowMatch).map((frow: FactTableRow) => {
                frow.facts.map((f: Fact) => {
                    var dim: DimensionReference | undefined = f.dimensions.find((dref: DimensionReference) => dref.axis.name === "Fund groups");
                    if (dim !== undefined && dim.member) {
                        fundList.push(dim.member.name);
                    }
                });
            });
        }
        return [...new Set(fundList)];
    }
    static addRowDimensions = function (currentAfr : Afr | null, rowMatch: MatchTableFacts): string[] {
        var dimList: string[] = [];
        if (currentAfr) {
            getMatchingFacts(currentAfr, rowMatch).map((frow: FactTableRow) => {
                frow.dimensions.map((dim: DimensionReference) => {
                    if (dim !== undefined && dim.member) {
                        dimList.push(utilityHelper.stripCodePrefix(dim.member.name));
                    }
                });
            });
        }
        return [...new Set(dimList)];
    }
    static showDeletePopup = function (currentAfr : Afr | null, rowMatch: MatchTableFacts, displayCode: string, dispatch: any) {
        var fundList = utilityHelper.addFundGroups(currentAfr, rowMatch);
        var flistText = "";
        if (fundList.length > 0) {
            flistText += "<br /><ul style='text-align:left;'>";
            fundList.map(s => flistText += "<li>" + utilityHelper.stripCodePrefix(s) + "</li>");
            flistText += "</ul></p>";
        } else {
            flistText = "</p>";
        }
        var dimList = utilityHelper.addRowDimensions(currentAfr,rowMatch);
        var dimlistText = "";
        if (dimList.length > 0) {
            dimlistText += " with attributes:<br /><ul style='text-align:left;'>";
            dimList.map(s => dimlistText += "<li>" + s + "</li>");
            dimlistText += "</ul><br />";
        } else {
            dimlistText = " ";
        }
        Swal.fire({
            title: '<b>DELETION WARNING</b>',
            html: "<p>Account code <b>" + displayCode + "</b>" + dimlistText + "has account information entered in the following fund groups: " + flistText
                + "<p>By deleting this account you will delete <b>all</b> financial information associated with it</p>"
                + "<p>Would you like to delete Account Code <b>" + displayCode + "</b>?</p>"
            ,
            icon: 'warning',
            allowOutsideClick: false,
            showCancelButton: true,
            showDenyButton: false,
            confirmButtonColor: '#3085d6',
            denyButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete Account Code!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result: any) => {
            if (result.isConfirmed) {
                //           row.getTable().deselectRow();
                var nextAccountCode = rowMatch.matchConcept.conceptName;
                dispatch(setIsDirty({ IsDirty: true, Page: "" }));
//                setDataKey(nextAccountCode);
                dispatch(clearMatchingTableFacts(rowMatch));
            }
        });
    }
    static trimAccountCode = function (label: string): string {
        var idx: number = label.indexOf(" - ");
        if (idx <= 0) {
            return label;
        }
        var acct: number = parseInt(label.substring(0, idx));
        if (isNaN(acct)) {
            return label;
        }
        // Do one more parse for a possible section account code (i.e. a range)
        return utilityHelper.trimAccountCode(label.substring(idx + 3));

    }

    static getReportTitleValue = function (taxonomyTypeString: string): string {
        var result: string = "";
        var taxonomyTypeValue = Object.values(TaxonomyTypeEnum).includes(taxonomyTypeString as TaxonomyTypeEnum) ? (taxonomyTypeString as TaxonomyTypeEnum) : null;
        if (taxonomyTypeValue != null) {

            switch (taxonomyTypeString) {
                case TaxonomyTypeEnum.AFR:
                    result = "AFR";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    result = "Court Report 29.0085";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    result = "Court Report 939.185";
                    break;

                default:
                    result = "";
                    break;
            }
        }

        return result;
    }

    static getEntityTypeText = function (entityCode: string): string {

        let result: string = "";

        const leftMostdigit = Number(entityCode[0]);


        switch (leftMostdigit) {

            case 1:
                result = "County";
                break;

            case 2:
                result = "City";
                break;

            case 3:
                result = "Special District"
                break;

            case 5:
                result = "Other Entity"
                break;

            default:
                break;
        }

        return result;
    }

    static getCR29FactsAndDocuments = function (currentAfr: Afr) {

        let result: string = "";
        // check if there is CR29 CPA Letter is uploaded or not
        if (currentAfr.currentversion.documents == null) {
            result = "NoCPALetter";
            return result;
        }

        // check if there is at least one fact in the tables, if not then move to work section
        if (currentAfr.currentversion.tables && currentAfr.currentversion.tables.length > 0) {
            currentAfr.currentversion.tables.map((t, ind) => {
                var facts = utilityHelper.getFilteredTableFacts(t, null, null);
                facts.map(f => {
                    if (f.value != 0) {
                        result = "HasFacts";
                        return result;
                    }
                });
            });
        }
        return result;
    }

    static getFundGroupMemberIdSetFromAfr = function (currentAfr: Afr | null, fundGroupName: string | null, tableName: string): Set<string> {

        let result: Set<string> = new Set<string>();

        if (currentAfr && currentAfr.year > 2023) {

            //Grab the member ids of the column hierarchy so we can compare the fact value member ids against the fund group member ids.
            if (fundGroupName) {

                var accountTableValue = getTable(currentAfr, tableName);

                if (accountTableValue && accountTableValue.structure && accountTableValue.structure.nthlevelcolumnHierarchy) {

                    //get the member ids of the column hierarchy for this account code.  A column hierarchy has a label and a list of sublevels.  Each sublevel has a dimension and a member id.
                    //component units currently don't have any sub levels.  So you have to just take the member id from the column hierarchy itself.
                    let fundGroupConceptMemberIds: TableBreakdownEntry[] = accountTableValue.structure.nthlevelcolumnHierarchy.filter((columnHierarchyValue: any) =>
                        (fundGroupName && columnHierarchyValue.label.toLowerCase() == fundGroupName.toLowerCase()));

                    if (fundGroupConceptMemberIds) {

                        result = new Set<string>(
                            fundGroupConceptMemberIds.flatMap((columnHierarchy: TableBreakdownEntry) =>
                                (columnHierarchy.sublevels
                                    ? columnHierarchy.sublevels.map((columnLevel: TableBreakdownEntry) => columnLevel.dimensionaspect.member ? columnLevel.dimensionaspect.member.id : null)
                                    : [columnHierarchy.dimensionaspect.member ? columnHierarchy.dimensionaspect.member.id : null])
                                    .filter((id): id is string => !!id)));

                    }
                }
            }
        }

        return result;
    }

}

